
// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Typography,
//   TextField,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Button,
//   Grid,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//     Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   IconButton
 
// } from '@mui/material';
// import SaveIcon from '@mui/icons-material/Save';
// import SearchIcon from '@mui/icons-material/Search';
// import CloseIcon from '@mui/icons-material/Close';
// import DownloadIcon from '@mui/icons-material/Download';

// const HearingEvaluationAdult = () => {
//   const [date, setDate] = useState('');
//   const [opNumber, setOpNumber] = useState('');
//   const [patientData, setPatientData] = useState(null);
//   const [demographyData, setDemographyData] = useState(null);

//   // Initial states for all hearing evaluation fields
//   const initialPureTone = {
//     equipmentUsed: '',
//     results: {
//       rightAC: Array(10).fill(''),
//       rightBC: Array(10).fill(''),
//       leftAC: Array(10).fill(''),
//       leftBC: Array(10).fill('')
//     },
//     weber: ['', '', '', '']
//   };

//   const initialSpeech = {
//     equipmentUsed: '',
//     rightEar: { srt: '', sis: '', sdt: '', ucl: '' },
//     leftEar: { srt: '', sis: '', sdt: '', ucl: '' }
//   };

//   const initialOtoscopy = {
//     equipmentUsed: '',
//     rightEar: '',
//     leftEar: ''
//   };

//   const initialTympanometry = {
//     equipmentUsed: '',
//     rightEar: { type: '', pp: '', sa: '', width: '', ecv: '' },
//     leftEar: { type: '', pp: '', sa: '', width: '', ecv: '' },
//     interpretation: ''
//   };

//   const initialReflexometry = {
//     equipmentUsed: '',
//     rightEar: { ipsi: ['', '', '', ''], contra: ['', '', '', ''] },
//     leftEar: { ipsi: ['', '', '', ''], contra: ['', '', '', ''] },
//     interpretation: ''
//   };

//   const initialReflexDecay = {
//     equipmentUsed: '',
//     rightEar: ['', ''],
//     leftEar: ['', ''],
//     interpretation: ''
//   };

//   const initialOae = {
//     equipmentUsed: '',
//     teoae: {
//       rightEar: Array(5).fill({ freq: '', snr: '', amplitude: '' }),
//       leftEar: Array(5).fill({ freq: '', snr: '', amplitude: '' })
//     },
//     dpoae: {
//       rightEar: Array(5).fill({ freq: '', snr: '', amplitude: '' }),
//       leftEar: Array(5).fill({ freq: '', snr: '', amplitude: '' }),
//       parameters: { f2f1: '', l1: '', l2: '' }
//     },
//     interpretation: ''
//   };

//   const initialAbr = {
//     equipmentUsed: '',
//     transducers: '',
//     stimulusRate: '',
//     stimulusType: '',
//     ear: '',
//     response: '',
//     results: Array(8).fill('').map(() => Array(9).fill(''))
//   };

//   const initialProvisionalDiagnosis = {
//     rightEar: '',
//     leftEar: ''
//   };
//   const [loading, setLoading] = useState(false);
//   const [saveStatus, setSaveStatus] = useState({ message: '', severity: '' });
//   const [openPasswordModal, setOpenPasswordModal] = useState(false);
//   const [password, setPassword] = useState('');
//   const [downloadFormat, setDownloadFormat] = useState('excel');
//   // State declarations
//   const [pureTone, setPureTone] = useState(initialPureTone);
//   const [speech, setSpeech] = useState(initialSpeech);
//   const [otoscopy, setOtoscopy] = useState(initialOtoscopy);
//   const [tympanometry, setTympanometry] = useState(initialTympanometry);
//   const [reflexometry, setReflexometry] = useState(initialReflexometry);
//   const [reflexDecay, setReflexDecay] = useState(initialReflexDecay);
//   const [oae, setOae] = useState(initialOae);
//   const [abr, setAbr] = useState(initialAbr);
//   const [previousEvaluations, setPreviousEvaluations] = useState([]);
//   const [provisionalDiagnosis, setProvisionalDiagnosis] = useState(initialProvisionalDiagnosis);

//   // Frequencies for pure tone audiometry
//   const frequencies = [250, 500, 750, 1000, 1500, 2000, 3000, 4000, 6000, 8000];


// // Add this function to your component
// const resetForm = () => {
//   setDate('');
//   setPureTone(initialPureTone);
//   setSpeech(initialSpeech);
//   setOtoscopy(initialOtoscopy);
//   setTympanometry(initialTympanometry);
//   setReflexometry(initialReflexometry);
//   setReflexDecay(initialReflexDecay);
//   setOae(initialOae);
//   setAbr(initialAbr);
//   setProvisionalDiagnosis(initialProvisionalDiagnosis);
// };

// // Search for patient
// const handleSearch = async () => {
//   try {
//     const response = await fetch(`http://localhost:5000/api/hearing-evaluation/search/${opNumber}`);
  
//       if (!response.ok) {
//         throw new Error("Failed to search for patient");
//       }
      
//       const patient = await response.json();
//       setPatientData(patient);
      
//       // Store in localStorage for future use
//       localStorage.setItem("demography", JSON.stringify(patient));
      
//       // Load previous evaluations for this patient
//       loadPreviousEvaluations(patient.id);
//     } catch (error) {
//       console.error("Error:", error);
//       setPatientData(null);
//       alert("❌ Patient not found. Please try another IP/OP number.");
//     }
//   };

//   // Load previous evaluations
//   const loadPreviousEvaluations = async (patientId) => {
//     try {
//       const response = await fetch(`http://localhost:5000/api/hearing-evaluation/patient/${patientId}`);
      
//       if (response.ok) {
//         const evaluations = await response.json();
//         setPreviousEvaluations(evaluations);
//       }
//     } catch (error) {
//       console.error("Error loading previous evaluations:", error);
//     }
//   };

//   useEffect(() => {
//     const data = localStorage.getItem("demography");
//     if (data) {
//       try {
//         const parsedData = JSON.parse(data);
//         setDemographyData(parsedData);
//       } catch (error) {
//         console.error("Error parsing demography data:", error);
//       }
//     }
//   }, []);

//   // Handler functions
//   const handlePureToneChange = (e) => {
//     const { name, value } = e.target;
//     setPureTone(prev => ({ ...prev, [name]: value }));
//   };

//   const handlePureToneResultChange = (ear, mode, index, value) => {
//     setPureTone(prev => {
//       const newResults = { ...prev.results };
//       newResults[`${ear}${mode}`][index] = value;
//       return { ...prev, results: newResults };
//     });
//   };

//   const handleWeberChange = (index, value) => {
//     setPureTone(prev => {
//       const newWeber = [...prev.weber];
//       newWeber[index] = value;
//       return { ...prev, weber: newWeber };
//     });
//   };

//   // Save handlers for each section
//   const savePureTone = () => {
//     console.log('Pure Tone saved:', pureTone);
//     alert('Pure Tone Audiometry data saved!');
//   };

//   const saveSpeech = () => {
//     console.log('Speech saved:', speech);
//     alert('Speech Audiometry data saved!');
//   };

//   const saveOtoscopy = () => {
//     console.log('Otoscopy saved:', otoscopy);
//     alert('Otoscopy data saved!');
//   };

//   const saveProvisionalDiagnosis = () => {
//     console.log('Provisional Diagnosis saved:', provisionalDiagnosis);
//     alert('Provisional Diagnosis data saved!');
//   };

//   const saveTympanometry = () => {
//     console.log('Tympanometry saved:', tympanometry);
//     alert('Tympanometry data saved!');
//   };

//   const saveReflexometry = () => {
//     console.log('Reflexometry saved:', reflexometry);
//     alert('Reflexometry data saved!');
//   };

//   const saveReflexDecay = () => {
//     console.log('Reflex Decay saved:', reflexDecay);
//     alert('Reflex Decay data saved!');
//   };

//   // OAE handlers
//   const handleOaeTeoaeChange = (ear, index, field, value) => {
//     setOae(prev => {
//       const newTeoae = { ...prev.teoae };
//       const newEarData = [...newTeoae[`${ear}Ear`]];
//       newEarData[index] = { ...newEarData[index], [field]: value };
//       newTeoae[`${ear}Ear`] = newEarData;
//       return { ...prev, teoae: newTeoae };
//     });
//   };

//   const handleOaeDpoaeChange = (ear, index, field, value) => {
//     setOae(prev => {
//       const newDpoae = { ...prev.dpoae };
//       const newEarData = [...newDpoae[`${ear}Ear`]];
//       newEarData[index] = { ...newEarData[index], [field]: value };
//       newDpoae[`${ear}Ear`] = newEarData;
//       return { ...prev, dpoae: newDpoae };
//     });
//   };

//   const handleOaeParamChange = (field, value) => {
//     setOae(prev => ({
//       ...prev,
//       dpoae: {
//         ...prev.dpoae,
//         parameters: {
//           ...prev.dpoae.parameters,
//           [field]: value
//         }
//       }
//     }));
//   };

//   const saveOae = () => {
//     console.log('OAE saved:', oae);
//     alert('OAE data saved!');
//   };

//   const saveAbr = () => {
//     console.log('ABR saved:', abr);
//     alert('ABR data saved!');
//   };

//   const handleAbrChange = (field, value) => {
//     setAbr(prev => ({ ...prev, [field]: value }));
//   };

//   const handleAbrResultChange = (rowIndex, colIndex, value) => {
//     setAbr(prev => {
//       const newResults = prev.results.map((row, rIndex) => {
//         if (rIndex === rowIndex) {
//           return row.map((cell, cIndex) => (cIndex === colIndex ? value : cell));
//         }
//         return row;
//       });
//       return { ...prev, results: newResults };
//     });
//   };

//   const handleSubmit = async () => {
//     try {
//       if (!patientData || !patientData.id) {
//         throw new Error("Patient information is missing. Please register the patient first.");
//       }

//       // Ensure all fields have proper values (not just empty strings)
//       const evaluationData = {
//         patientId: patientData.id,
//         date: date,
//         // Demographic data
//         patientName: patientData.name || '',
//         patientPhone: patientData.phone || '',
//         patientIpNumber: patientData.ip_number || '',
//         patientOpNumber: patientData.op_number || '',
//         patientAddress: patientData.address || '',
//         // Hearing evaluation data - ensure all sections are properly formatted
//         pureTone: {
//           equipmentUsed: pureTone.equipmentUsed || '',
//           results: {
//             rightAC: pureTone.results.rightAC.map(val => val || null),
//             rightBC: pureTone.results.rightBC.map(val => val || null),
//             leftAC: pureTone.results.leftAC.map(val => val || null),
//             leftBC: pureTone.results.leftBC.map(val => val || null)
//           },
//           weber: pureTone.weber.map(val => val || null)
//         },
//         speech: {
//           equipmentUsed: speech.equipmentUsed || '',
//           rightEar: {
//             srt: speech.rightEar.srt || null,
//             sis: speech.rightEar.sis || null,
//             sdt: speech.rightEar.sdt || null,
//             ucl: speech.rightEar.ucl || null
//           },
//           leftEar: {
//             srt: speech.leftEar.srt || null,
//             sis: speech.leftEar.sis || null,
//             sdt: speech.leftEar.sdt || null,
//             ucl: speech.leftEar.ucl || null
//           }
//         },
//         otoscopy: {
//           equipmentUsed: otoscopy.equipmentUsed || '',
//           rightEar: otoscopy.rightEar || '',
//           leftEar: otoscopy.leftEar || ''
//         },
//         tympanometry: {
//           equipmentUsed: tympanometry.equipmentUsed || '',
//           rightEar: {
//             type: tympanometry.rightEar.type || '',
//             pp: tympanometry.rightEar.pp || null,
//             sa: tympanometry.rightEar.sa || null,
//             width: tympanometry.rightEar.width || null,
//             ecv: tympanometry.rightEar.ecv || null
//           },
//           leftEar: {
//             type: tympanometry.leftEar.type || '',
//             pp: tympanometry.leftEar.pp || null,
//             sa: tympanometry.leftEar.sa || null,
//             width: tympanometry.leftEar.width || null,
//             ecv: tympanometry.leftEar.ecv || null
//           },
//           interpretation: tympanometry.interpretation || ''
//         },
//         reflexometry: {
//           equipmentUsed: reflexometry.equipmentUsed || '',
//           rightEar: {
//             ipsi: reflexometry.rightEar.ipsi.map(val => val || null),
//             contra: reflexometry.rightEar.contra.map(val => val || null)
//           },
//           leftEar: {
//             ipsi: reflexometry.leftEar.ipsi.map(val => val || null),
//             contra: reflexometry.leftEar.contra.map(val => val || null)
//           },
//           interpretation: reflexometry.interpretation || ''
//         },
//         reflexDecay: {
//           equipmentUsed: reflexDecay.equipmentUsed || '',
//           rightEar: reflexDecay.rightEar.map(val => val || null),
//           leftEar: reflexDecay.leftEar.map(val => val || null),
//           interpretation: reflexDecay.interpretation || ''
//         },
//         oae: {
//           equipmentUsed: oae.equipmentUsed || '',
//           teoae: {
//             rightEar: oae.teoae.rightEar.map(item => ({
//               freq: item.freq || null,
//               snr: item.snr || null,
//               amplitude: item.amplitude || null
//             })),
//             leftEar: oae.teoae.leftEar.map(item => ({
//               freq: item.freq || null,
//               snr: item.snr || null,
//               amplitude: item.amplitude || null
//             }))
//           },
//           dpoae: {
//             parameters: {
//               f2f1: oae.dpoae.parameters.f2f1 || null,
//               l1: oae.dpoae.parameters.l1 || null,
//               l2: oae.dpoae.parameters.l2 || null
//             },
//             rightEar: oae.dpoae.rightEar.map(item => ({
//               freq: item.freq || null,
//               snr: item.snr || null,
//               amplitude: item.amplitude || null
//             })),
//             leftEar: oae.dpoae.leftEar.map(item => ({
//               freq: item.freq || null,
//               snr: item.snr || null,
//               amplitude: item.amplitude || null
//             }))
//           },
//           interpretation: oae.interpretation || ''
//         },
//         abr: {
//           equipmentUsed: abr.equipmentUsed || '',
//           transducers: abr.transducers || '',
//           stimulusRate: abr.stimulusRate || '',
//           stimulusType: abr.stimulusType || '',
//           ear: abr.ear || '',
//           response: abr.response || '',
//           results: abr.results.map(row => row.map(cell => cell || null))
//         },
//         provisionalDiagnosis: {
//           rightEar: provisionalDiagnosis.rightEar || '',
//           leftEar: provisionalDiagnosis.leftEar || ''
//         }
//       };
// console.log('Submitting evaluation data:', evaluationData);
//      const response = await fetch("http://localhost:5000/api/hearing-evaluation", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(evaluationData),
//     });

//     if (!response.ok) {
//       const errorText = await response.text();
//       throw new Error(errorText || "Failed to save hearing evaluation data");
//     }

//     const data = await response.json();
//     alert("✅ Hearing evaluation data saved successfully!");
//     console.log("Saved:", data);
    
//     // Reset the form after successful submission
//     resetForm();
    
//     loadPreviousEvaluations(patientData.id);
//   } catch (error) {
//     console.error("Error:", error);
//     alert(`❌ ${error.message}`);
//   }
// };


//   const handleDownloadClick = () => {
//     setOpenPasswordModal(true);
//   };

// const handleDownloadConfirm = async () => {
//   const correctKey = "Varun@6361";

//   // Validate key entered in modal
//   if (password !== correctKey) {
//     alert("Incorrect key! Download canceled.");
//     setPassword('');
//     setOpenPasswordModal(false);
//     return;
//   }

//   setOpenPasswordModal(false);
//   setLoading(true);
//   setSaveStatus({
//     message: `Requesting Hearing Evaluation Data  ${downloadFormat}...`,
//     severity: "info",
//   });

//   try {
//     const resp = await fetch(
//       "http://localhost:5000/api/reports/download-form",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           table: "hearing_evaluation_data",
//           formName: "Hearing_Evaluation_Data",
//           format: downloadFormat,
//           key: password   // 🔥 send KEY instead of password
//         }),
//       }
//     );

//     if (!resp.ok) {
//       const body = await resp.json().catch(() => ({}));
//       setSaveStatus({
//         message: `Failed: ${body.message || resp.statusText}`,
//         severity: "error",
//       });
//       return;
//     }

//     const blob = await resp.blob();
//     const disposition = resp.headers.get("content-disposition") || "";

//     let filename = `Hearing_Evaluation_Data_${Date.now()}.${
//       downloadFormat === "excel" ? "xlsx" : "pdf"
//     }`;

//     const match = /filename="?([^"]+)"?/.exec(disposition);
//     if (match && match[1]) filename = match[1];

//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = filename;
//     document.body.appendChild(a);
//     a.click();
//     a.remove();
//     window.URL.revokeObjectURL(url);

//     setSaveStatus({
//       message: `Download started: ${filename}`,
//       severity: "success",
//     });

//   } catch (err) {
//     console.error("Download error:", err);
//     setSaveStatus({
//       message: `Error downloading file: ${err.message}`,
//       severity: "error",
//     });
//   } finally {
//     setLoading(false);
//     setPassword('');
//   }
// };


//   const handlePasswordModalClose = () => {
//     setOpenPasswordModal(false);
//     setPassword('');
//   };


//   return (
//     <Paper elevation={3} sx={{ p: 4, maxWidth: 1400, margin: 'auto', mt: 4, mb: 6 }}>

       
//       <Typography variant="h4" gutterBottom fontWeight="bold" color="secondary" align="center">
//         Adult Hearing Evaluation
//       </Typography>

//       {/* Patient Search Section */}
//       <Box mb={4} border={1} borderColor="divider" p={2} borderRadius={2}>
//         <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
//           Patient Identification
//         </Typography>

//         <Grid container spacing={2} alignItems="center">
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="IP/OP Number"
//               value={opNumber}
//               onChange={(e) => setOpNumber(e.target.value)}
//               variant="outlined"
//               fullWidth
//             />
//           </Grid>
//           <Grid item xs={12} md={6}>
//             <Button
//               variant="contained"
//               color="primary"
//               startIcon={<SearchIcon />}
//               onClick={handleSearch}
//               sx={{ px: 4, py: 1.5 }}
//             >
//               Search Patient
//             </Button>
//           </Grid>
//         </Grid>
//       </Box>

//       {/* Patient Information - Visible after search */}
//       {patientData && (
//         <Paper elevation={2} sx={{ p: 2, mb: 3, backgroundColor: '#e3f2fd' }}>
//            <Box sx={{ position: 'absolute', top: 350, right: 70 }}>
//               <Button
//                 variant="contained"
//                 color="secondary"
//                 startIcon={<DownloadIcon />}
//                 onClick={handleDownloadClick}
//                 disabled={loading}
//                 sx={{ 
//                   borderRadius: 2,
//                   boxShadow: 2,
//                   '&:hover': {
//                     boxShadow: 4,
//                     transform: 'translateY(-2px)',
//                     transition: 'all 0.3s ease'
//                   }
//                 }}
//               >
//                 Download 
//               </Button>
//             </Box>
//           <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
//             Patient Information
//           </Typography>
//           <Grid container spacing={2}>
//             <Grid item xs={12} sm={6} md={3}>
//               <Typography><strong>Name:</strong> {patientData.name}</Typography>
//             </Grid>
//             <Grid item xs={12} sm={6} md={3}>
//               <Typography><strong>Age:</strong> {patientData.age}</Typography>
//             </Grid>
//             <Grid item xs={12} sm={6} md={3}>
//               <Typography><strong>IP Number:</strong> {patientData.ip_number}</Typography>
//             </Grid>
//             <Grid item xs={12} sm={6} md={3}>
//               <Typography><strong>OP Number:</strong> {patientData.op_number || 'N/A'}</Typography>
//             </Grid>
//             <Grid item xs={12} sm={6} md={3}>
//               <Typography><strong>Phone:</strong> {patientData.phone}</Typography>
//             </Grid>
//             <Grid item xs={12} sm={6} md={3}>
//               <Typography><strong>Address:</strong> {patientData.address || 'N/A'}</Typography>
//             </Grid>
//             <Grid item xs={12}>
//               <Typography><strong>Medical History:</strong> {patientData.history || 'N/A'}</Typography>
//             </Grid>
//           </Grid>
//         </Paper>
//       )}

//       {/* Only show the form if a patient is found */}
//       {patientData && (
//         <>
//           {/* Pure Tone Audiometry Section */}
//           {/* Date of Assessment */}
//           <Box mb={4} border={1} borderColor="divider" p={2} borderRadius={2}>
//             <Grid item xs={12} md={6}>
//               <TextField
//                 fullWidth
//                 name="dateOfAssessment"
//                 label="Date of Assessment"
//                 type="date"
//                 value={date}
//                 onChange={(e) => setDate(e.target.value)}
//                 InputLabelProps={{ shrink: true }}
//               />
//             </Grid>
//           </Box>
//           <Box mb={4} border={1} borderColor="divider" p={2} borderRadius={2}>
//             <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
//               Pure Tone Audiometry
//             </Typography>

//             <Grid container spacing={2} sx={{ mb: 2 }}>
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   label="Equipment Used"
//                   name="equipmentUsed"
//                   value={pureTone.equipmentUsed}
//                   onChange={handlePureToneChange}
//                   variant="outlined"
//                 />
//               </Grid>
//             </Grid>

//             <TableContainer component={Paper} sx={{ mb: 2 }}>
//               <Table size="small">
//                 <TableHead>
//                   <TableRow>
//                     <TableCell>Mode/Ear</TableCell>
//                     {frequencies.map(freq => (
//                       <TableCell key={freq} align="center">{freq} Hz</TableCell>
//                     ))}
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {[['AC', 'Right'], ['BC', 'Right'], ['AC', 'Left'], ['BC', 'Left']].map(([mode, ear]) => (
//                     <TableRow key={`${mode}-${ear}`}>
//                       <TableCell>{mode} - {ear}</TableCell>
//                       {frequencies.map((_, index) => (
//                         <TableCell key={index} align="center">
//                           <TextField
//                             size="small"
//                             type="number"
//                             value={pureTone.results[`${ear.toLowerCase()}${mode}`][index]}
//                             onChange={(e) => handlePureToneResultChange(
//                               ear.toLowerCase(),
//                               mode,
//                               index,
//                               e.target.value
//                             )}
//                             sx={{ width: 60 }}
//                           />
//                         </TableCell>
//                       ))}
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>

//             <Button
//               variant="contained"
//               startIcon={<SaveIcon />}
//               onClick={savePureTone}
//               sx={{ mt: 2 }}
//             >
//               Save Pure Tone
//             </Button>
//           </Box>

//           {/* Weber Test Section */}
//           <Box mb={4} border={1} borderColor="divider" p={2} borderRadius={2}>
//             <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
//               Weber Test
//             </Typography>
//             <Grid container spacing={2} sx={{ mb: 2 }}>
//               {[250, 500, 1000, 2000].map((freq, index) => (
//                 <Grid item xs={6} sm={3} key={freq}>
//                   <FormControl fullWidth>
//                     <InputLabel shrink={true}>{freq} Hz</InputLabel>
//                     <Select
//                       value={pureTone.weber[index]}
//                       onChange={(e) => handleWeberChange(index, e.target.value)}
//                       label={`${freq} Hz`}
//                       displayEmpty
//                       renderValue={value => value || "Select Weber"}
//                     >
//                       <MenuItem value="L">Left</MenuItem>
//                       <MenuItem value="R">Right</MenuItem>
//                       <MenuItem value="C">Center</MenuItem>
//                     </Select>
//                   </FormControl>
//                 </Grid>
//               ))}
//             </Grid>
//           </Box>

//           {/* Speech Audiometry Section */}
//           <Box mb={4} border={1} borderColor="divider" p={2} borderRadius={2}>
//             <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
//               Speech Audiometry
//             </Typography>

//             <Grid container spacing={2} sx={{ mb: 2 }}>
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   label="Equipment Used"
//                   name="equipmentUsed"
//                   value={speech.equipmentUsed}
//                   onChange={(e) => setSpeech(prev => ({ ...prev, equipmentUsed: e.target.value }))}
//                   variant="outlined"
//                 />
//               </Grid>
//             </Grid>

//             <TableContainer component={Paper} sx={{ mb: 2 }}>
//               <Table size="small">
//                 <TableHead>
//                   <TableRow>
//                     <TableCell>Ear</TableCell>
//                     <TableCell align="center">SRT (dB HL)</TableCell>
//                     <TableCell align="center">SIS (%)</TableCell>
//                     <TableCell align="center">SDT (dB HL)</TableCell>
//                     <TableCell align="center">UCL (dB HL)</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   <TableRow>
//                     <TableCell>Right</TableCell>
//                     <TableCell align="center">
//                       <TextField
//                         size="small"
//                         type="number"
//                         fullWidth
//                         value={speech.rightEar.srt}
//                         onChange={(e) => setSpeech(prev => ({
//                           ...prev,
//                           rightEar: { ...prev.rightEar, srt: e.target.value }
//                         }))}
//                       />
//                     </TableCell>
//                     <TableCell align="center">
//                       <TextField
//                         size="small"
//                         type="number"
//                         fullWidth
//                         value={speech.rightEar.sis}
//                         onChange={(e) => setSpeech(prev => ({
//                           ...prev,
//                           rightEar: { ...prev.rightEar, sis: e.target.value }
//                         }))}
//                       />
//                     </TableCell>
//                     <TableCell align="center">
//                       <TextField
//                         size="small"
//                         type="number"
//                         fullWidth
//                         value={speech.rightEar.sdt}
//                         onChange={(e) => setSpeech(prev => ({
//                           ...prev,
//                           rightEar: { ...prev.rightEar, sdt: e.target.value }
//                         }))}
//                       />
//                     </TableCell>
//                     <TableCell align="center">
//                       <TextField
//                         size="small"
//                         type="number"
//                         fullWidth
//                         value={speech.rightEar.ucl}
//                         onChange={(e) => setSpeech(prev => ({
//                           ...prev,
//                           rightEar: { ...prev.rightEar, ucl: e.target.value }
//                         }))}
//                       />
//                     </TableCell>
//                   </TableRow>
//                   <TableRow>
//                     <TableCell>Left</TableCell>
//                     <TableCell align="center">
//                       <TextField
//                         size="small"
//                         type="number"
//                         fullWidth
//                         value={speech.leftEar.srt}
//                         onChange={(e) => setSpeech(prev => ({
//                           ...prev,
//                           leftEar: { ...prev.leftEar, srt: e.target.value }
//                         }))}
//                       />
//                     </TableCell>
//                     <TableCell align="center">
//                       <TextField
//                         size="small"
//                         type="number"
//                         fullWidth
//                         value={speech.leftEar.sis}
//                         onChange={(e) => setSpeech(prev => ({
//                           ...prev,
//                           leftEar: { ...prev.leftEar, sis: e.target.value }
//                         }))}
//                       />
//                     </TableCell>
//                     <TableCell align="center">
//                       <TextField
//                         size="small"
//                         type="number"
//                         fullWidth
//                         value={speech.leftEar.sdt}
//                         onChange={(e) => setSpeech(prev => ({
//                           ...prev,
//                           leftEar: { ...prev.leftEar, sdt: e.target.value }
//                         }))}
//                       />
//                     </TableCell>
//                     <TableCell align="center">
//                       <TextField
//                         size="small"
//                         type="number"
//                         fullWidth
//                         value={speech.leftEar.ucl}
//                         onChange={(e) => setSpeech(prev => ({
//                           ...prev,
//                           leftEar: { ...prev.leftEar, ucl: e.target.value }
//                         }))}
//                       />
//                     </TableCell>
//                   </TableRow>
//                 </TableBody>
//               </Table>
//             </TableContainer>

//             <Button
//               variant="contained"
//               startIcon={<SaveIcon />}
//               onClick={saveSpeech}
//               sx={{ mt: 2 }}
//             >
//               Save Speech
//             </Button>
//           </Box>

//           {/* Otoscopy Section */}
//           <Box mb={4} border={1} borderColor="divider" p={2} borderRadius={2}>
//             <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
//               Otoscopy
//             </Typography>

//             <Grid container spacing={2} sx={{ mb: 2 }}>
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   label="Equipment Used"
//                   value={otoscopy.equipmentUsed}
//                   onChange={(e) => setOtoscopy(prev => ({ ...prev, equipmentUsed: e.target.value }))}
//                   variant="outlined"
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   label="Right Ear Findings"
//                   value={otoscopy.rightEar}
//                   onChange={(e) => setOtoscopy(prev => ({ ...prev, rightEar: e.target.value }))}
//                   variant="outlined"
//                 />
//               </Grid>
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   label="Left Ear Findings"
//                   value={otoscopy.leftEar}
//                   onChange={(e) => setOtoscopy(prev => ({ ...prev, leftEar: e.target.value }))}
//                   variant="outlined"
//                 />
//               </Grid>
//             </Grid>

//             <Button
//               variant="contained"
//               startIcon={<SaveIcon />}
//               onClick={saveOtoscopy}
//               sx={{ mt: 2 }}
//             >
//               Save Otoscopy
//             </Button>
//           </Box>

//           {/* Tympanometry Section */}
//           <Box mb={4} border={1} borderColor="divider" p={2} borderRadius={2}>
//             <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
//               Tympanometry
//             </Typography>

//             <Grid container spacing={2} sx={{ mb: 2 }}>
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   label="Equipment Used"
//                   value={tympanometry.equipmentUsed}
//                   onChange={(e) => setTympanometry(prev => ({ ...prev, equipmentUsed: e.target.value }))}
//                   variant="outlined"
//                 />
//               </Grid>
//             </Grid>

//             <TableContainer component={Paper} sx={{ mb: 2 }}>
//               <Table size="small">
//                 <TableHead>
//                   <TableRow>
//                     <TableCell>Ear</TableCell>
//                     <TableCell align="center">Type</TableCell>
//                     <TableCell align="center">PP (daPa)</TableCell>
//                     <TableCell align="center">SA (mmho)</TableCell>
//                     <TableCell align="center">Width (daPa)</TableCell>
//                     <TableCell align="center">ECV (cc)</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   <TableRow>
//                     <TableCell>Right</TableCell>
//                     <TableCell align="center">
//                       <TextField
//                         size="small"
//                         value={tympanometry.rightEar.type}
//                         onChange={(e) => setTympanometry(prev => ({
//                           ...prev,
//                           rightEar: { ...prev.rightEar, type: e.target.value }
//                         }))}
//                         fullWidth
//                       />
//                     </TableCell>
//                     <TableCell align="center">
//                       <TextField
//                         size="small"
//                         type="number"
//                         value={tympanometry.rightEar.pp}
//                         onChange={(e) => setTympanometry(prev => ({
//                           ...prev,
//                           rightEar: { ...prev.rightEar, pp: e.target.value }
//                         }))}
//                         fullWidth
//                       />
//                     </TableCell>
//                     <TableCell align="center">
//                       <TextField
//                         size="small"
//                         type="number"
//                         value={tympanometry.rightEar.sa}
//                         onChange={(e) => setTympanometry(prev => ({
//                           ...prev,
//                           rightEar: { ...prev.rightEar, sa: e.target.value }
//                         }))}
//                         fullWidth
//                       />
//                     </TableCell>
//                     <TableCell align="center">
//                       <TextField
//                         size="small"
//                         type="number"
//                         value={tympanometry.rightEar.width}
//                         onChange={(e) => setTympanometry(prev => ({
//                           ...prev,
//                           rightEar: { ...prev.rightEar, width: e.target.value }
//                         }))}
//                         fullWidth
//                       />
//                     </TableCell>
//                     <TableCell align="center">
//                       <TextField
//                         size="small"
//                         type="number"
//                         value={tympanometry.rightEar.ecv}
//                         onChange={(e) => setTympanometry(prev => ({
//                           ...prev,
//                           rightEar: { ...prev.rightEar, ecv: e.target.value }
//                         }))}
//                         fullWidth
//                       />
//                     </TableCell>
//                   </TableRow>
//                   <TableRow>
//                     <TableCell>Left</TableCell>
//                     <TableCell align="center">
//                       <TextField
//                         size="small"
//                         value={tympanometry.leftEar.type}
//                         onChange={(e) => setTympanometry(prev => ({
//                           ...prev,
//                           leftEar: { ...prev.leftEar, type: e.target.value }
//                         }))}
//                         fullWidth
//                       />
//                     </TableCell>
//                     <TableCell align="center">
//                       <TextField
//                         size="small"
//                         type="number"
//                         value={tympanometry.leftEar.pp}
//                         onChange={(e) => setTympanometry(prev => ({
//                           ...prev,
//                           leftEar: { ...prev.leftEar, pp: e.target.value }
//                         }))}
//                         fullWidth
//                       />
//                     </TableCell>
//                     <TableCell align="center">
//                       <TextField
//                         size="small"
//                         type="number"
//                         value={tympanometry.leftEar.sa}
//                         onChange={(e) => setTympanometry(prev => ({
//                           ...prev,
//                           leftEar: { ...prev.leftEar, sa: e.target.value }
//                         }))}
//                         fullWidth
//                       />
//                     </TableCell>
//                     <TableCell align="center">
//                       <TextField
//                         size="small"
//                         type="number"
//                         value={tympanometry.leftEar.width}
//                         onChange={(e) => setTympanometry(prev => ({
//                           ...prev,
//                           leftEar: { ...prev.leftEar, width: e.target.value }
//                         }))}
//                         fullWidth
//                       />
//                     </TableCell>
//                     <TableCell align="center">
//                       <TextField
//                         size="small"
//                         type="number"
//                         value={tympanometry.leftEar.ecv}
//                         onChange={(e) => setTympanometry(prev => ({
//                           ...prev,
//                           leftEar: { ...prev.leftEar, ecv: e.target.value }
//                         }))}
//                         fullWidth
//                       />
//                     </TableCell>
//                   </TableRow>
//                 </TableBody>
//               </Table>
//             </TableContainer>

//             <TextField
//               fullWidth
//               multiline
//               rows={3}
//               label="Interpretation"
//               value={tympanometry.interpretation}
//               onChange={(e) => setTympanometry(prev => ({ ...prev, interpretation: e.target.value }))}
//               variant="outlined"
//               sx={{ mb: 2 }}
//             />

//             <Button
//               variant="contained"
//               startIcon={<SaveIcon />}
//               onClick={saveTympanometry}
//               sx={{ mt: 2 }}
//             >
//               Save Tympanometry
//             </Button>
//           </Box>

//           {/* Reflexometry Section */}
//           <Box mb={4} border={1} borderColor="divider" p={2} borderRadius={2}>
//             <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
//               Reflexometry
//             </Typography>

//             <Grid container spacing={2} sx={{ mb: 2 }}>
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   label="Equipment Used"
//                   value={reflexometry.equipmentUsed}
//                   onChange={(e) => setReflexometry(prev => ({ ...prev, equipmentUsed: e.target.value }))}
//                   variant="outlined"
//                 />
//               </Grid>
//             </Grid>

//             <Typography variant="subtitle1" gutterBottom>
//               Right Ear
//             </Typography>
//             <TableContainer component={Paper} sx={{ mb: 2 }}>
//               <Table size="small">
//                 <TableHead>
//                   <TableRow>
//                     <TableCell>Type</TableCell>
//                     <TableCell align="center">500 Hz</TableCell>
//                     <TableCell align="center">1000 Hz</TableCell>
//                     <TableCell align="center">2000 Hz</TableCell>
//                     <TableCell align="center">4000 Hz</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   <TableRow>
//                     <TableCell>IPSI</TableCell>
//                     {[0, 1, 2, 3].map((index) => (
//                       <TableCell key={`right-ipsi-${index}`} align="center">
//                         <TextField
//                           size="small"
//                           type="number"
//                           fullWidth
//                           value={reflexometry.rightEar.ipsi[index]}
//                           onChange={(e) => {
//                             const newIpsi = [...reflexometry.rightEar.ipsi];
//                             newIpsi[index] = e.target.value;
//                             setReflexometry(prev => ({
//                               ...prev,
//                               rightEar: { ...prev.rightEar, ipsi: newIpsi }
//                             }));
//                           }}
//                         />
//                       </TableCell>
//                     ))}
//                   </TableRow>
//                   <TableRow>
//                     <TableCell>CONTRA</TableCell>
//                     {[0, 1, 2, 3].map((index) => (
//                       <TableCell key={`right-contra-${index}`} align="center">
//                         <TextField
//                           size="small"
//                           type="number"
//                           fullWidth
//                           value={reflexometry.rightEar.contra[index]}
//                           onChange={(e) => {
//                             const newContra = [...reflexometry.rightEar.contra];
//                             newContra[index] = e.target.value;
//                             setReflexometry(prev => ({
//                               ...prev,
//                               rightEar: { ...prev.rightEar, contra: newContra }
//                             }));
//                           }}
//                         />
//                       </TableCell>
//                     ))}
//                   </TableRow>
//                 </TableBody>
//               </Table>
//             </TableContainer>

//             <Typography variant="subtitle1" gutterBottom>
//               Left Ear
//             </Typography>
//             <TableContainer component={Paper} sx={{ mb: 2 }}>
//               <Table size="small">
//                 <TableHead>
//                   <TableRow>
//                     <TableCell>Type</TableCell>
//                     <TableCell align="center">500 Hz</TableCell>
//                     <TableCell align="center">1000 Hz</TableCell>
//                     <TableCell align="center">2000 Hz</TableCell>
//                     <TableCell align="center">4000 Hz</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   <TableRow>
//                     <TableCell>IPSI</TableCell>
//                     {[0, 1, 2, 3].map((index) => (
//                       <TableCell key={`left-ipsi-${index}`} align="center">
//                         <TextField
//                           size="small"
//                           type="number"
//                           fullWidth
//                           value={reflexometry.leftEar.ipsi[index]}
//                           onChange={(e) => {
//                             const newIpsi = [...reflexometry.leftEar.ipsi];
//                             newIpsi[index] = e.target.value;
//                             setReflexometry(prev => ({
//                               ...prev,
//                               leftEar: { ...prev.leftEar, ipsi: newIpsi }
//                             }));
//                           }}
//                         />
//                       </TableCell>
//                     ))}
//                   </TableRow>
//                   <TableRow>
//                     <TableCell>CONTRA</TableCell>
//                     {[0, 1, 2, 3].map((index) => (
//                       <TableCell key={`left-contra-${index}`} align="center">
//                         <TextField
//                           size="small"
//                           type="number"
//                           fullWidth
//                           value={reflexometry.leftEar.contra[index]}
//                           onChange={(e) => {
//                             const newContra = [...reflexometry.leftEar.contra];
//                             newContra[index] = e.target.value;
//                             setReflexometry(prev => ({
//                               ...prev,
//                               leftEar: { ...prev.leftEar, contra: newContra }
//                             }));
//                           }}
//                         />
//                       </TableCell>
//                     ))}
//                   </TableRow>
//                 </TableBody>
//               </Table>
//             </TableContainer>

//             <TextField
//               fullWidth
//               multiline
//               rows={3}
//               label="Interpretation"
//               value={reflexometry.interpretation}
//               onChange={(e) => setReflexometry(prev => ({ ...prev, interpretation: e.target.value }))}
//               variant="outlined"
//               sx={{ mb: 2 }}
//             />

//             <Button
//               variant="contained"
//               startIcon={<SaveIcon />}
//               onClick={saveReflexometry}
//               sx={{ mt: 2 }}
//             >
//               Save Reflexometry
//             </Button>
//           </Box>

//           {/* Reflex Decay Section */}
//           <Box mb={4} border={1} borderColor="divider" p={2} borderRadius={2}>
//             <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
//               Reflex Decay
//             </Typography>

//             <Grid container spacing={2} sx={{ mb: 2 }}>
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   label="Equipment Used"
//                   value={reflexDecay.equipmentUsed}
//                   onChange={(e) => setReflexDecay(prev => ({ ...prev, equipmentUsed: e.target.value }))}
//                   variant="outlined"
//                 />
//               </Grid>
//             </Grid>

//             <Typography variant="subtitle1" gutterBottom>
//               Right Ear
//             </Typography>
//             <Grid container spacing={2} sx={{ mb: 2 }}>
//               <Grid item xs={6}>
//                 <FormControl fullWidth>
//                   <InputLabel shrink={true}>500 Hz</InputLabel>
//                   <Select
//                     value={reflexDecay.rightEar[0]}
//                     onChange={(e) => {
//                       const newRightEar = [...reflexDecay.rightEar];
//                       newRightEar[0] = e.target.value;
//                       setReflexDecay(prev => ({ ...prev, rightEar: newRightEar }));
//                     }}
//                     label="500 Hz"
//                     displayEmpty
//                     renderValue={value => value || "Select"}
//                   >
//                     <MenuItem value="Positive">Positive</MenuItem>
//                     <MenuItem value="Negative">Negative</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid item xs={6}>
//                 <FormControl fullWidth>
//                   <InputLabel shrink={true}>1000 Hz</InputLabel>
//                   <Select
//                     value={reflexDecay.rightEar[1]}
//                     onChange={(e) => {
//                       const newRightEar = [...reflexDecay.rightEar];
//                       newRightEar[1] = e.target.value;
//                       setReflexDecay(prev => ({ ...prev, rightEar: newRightEar }));
//                     }}
//                     label="1000 Hz"
//                     displayEmpty
//                     renderValue={value => value || "Select"}
//                   >
//                     <MenuItem value="Positive">Positive</MenuItem>
//                     <MenuItem value="Negative">Negative</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//             </Grid>

//             <Typography variant="subtitle1" gutterBottom>
//               Left Ear
//             </Typography>
//             <Grid container spacing={2} sx={{ mb: 2 }}>
//               <Grid item xs={6}>
//                 <FormControl fullWidth>
//                   <InputLabel shrink={true}>500 Hz</InputLabel>
//                   <Select
//                     value={reflexDecay.leftEar[0]}
//                     onChange={(e) => {
//                       const newLeftEar = [...reflexDecay.leftEar];
//                       newLeftEar[0] = e.target.value;
//                       setReflexDecay(prev => ({ ...prev, leftEar: newLeftEar }));
//                     }}
//                     label="500 Hz"
//                     displayEmpty
//                     renderValue={value => value || "Select"}
//                   >
//                     <MenuItem value="Positive">Positive</MenuItem>
//                     <MenuItem value="Negative">Negative</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid item xs={6}>
//                 <FormControl fullWidth>
//                   <InputLabel shrink={true}>1000 Hz</InputLabel>
//                   <Select
//                     value={reflexDecay.leftEar[1]}
//                     onChange={(e) => {
//                       const newLeftEar = [...reflexDecay.leftEar];
//                       newLeftEar[1] = e.target.value;
//                       setReflexDecay(prev => ({ ...prev, leftEar: newLeftEar }));
//                     }}
//                     label="1000 Hz"
//                     displayEmpty
//                     renderValue={value => value || "Select"}
//                   >
//                     <MenuItem value="Positive">Positive</MenuItem>
//                     <MenuItem value="Negative">Negative</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//             </Grid>

//             <TextField
//               fullWidth
//               multiline
//               rows={3}
//               label="Interpretation"
//               value={reflexDecay.interpretation}
//               onChange={(e) => setReflexDecay(prev => ({ ...prev, interpretation: e.target.value }))}
//               variant="outlined"
//               sx={{ mb: 2 }}
//             />

//             <Button
//               variant="contained"
//               startIcon={<SaveIcon />}
//               onClick={saveReflexDecay}
//               sx={{ mt: 2 }}
//             >
//               Save Reflex Decay
//             </Button>
//           </Box>

//           {/* OAE Section */}
//           <Box mb={4} border={1} borderColor="divider" p={2} borderRadius={2}>
//             <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
//               Oto-acoustic Emissions (OAE)
//             </Typography>

//             <Grid container spacing={2} sx={{ mb: 2 }}>
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   label="Equipment Used"
//                   value={oae.equipmentUsed}
//                   onChange={(e) => setOae(prev => ({ ...prev, equipmentUsed: e.target.value }))}
//                   variant="outlined"
//                 />
//               </Grid>
//             </Grid>

//             {/* TEOAE Section */}
//             <Typography variant="h6" gutterBottom color="primary">
//               TEOAE
//             </Typography>
//             <Grid container spacing={3} sx={{ mb: 4 }}>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle1" fontWeight="bold">Right Ear</Typography>
//                 <TableContainer component={Paper} sx={{ mb: 2 }}>
//                   <Table size="small">
//                     <TableHead>
//                       <TableRow>
//                         <TableCell>Frequency (KHz)</TableCell>
//                         <TableCell align="center">SNR (dB SPL)</TableCell>
//                         <TableCell align="center">Amplitude (dB SPL)</TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {oae.teoae.rightEar.map((result, index) => (
//                         <TableRow key={`teoae-right-${index}`}>
//                           <TableCell>
//                             <TextField
//                               size="small"
//                               value={result.freq}
//                               onChange={(e) => handleOaeTeoaeChange('right', index, 'freq', e.target.value)}
//                               fullWidth
//                             />
//                           </TableCell>
//                           <TableCell align="center">
//                             <TextField
//                               size="small"
//                               type="number"
//                               value={result.snr}
//                               onChange={(e) => handleOaeTeoaeChange('right', index, 'snr', e.target.value)}
//                               fullWidth
//                             />
//                           </TableCell>
//                           <TableCell align="center">
//                             <TextField
//                               size="small"
//                               type="number"
//                               value={result.amplitude}
//                               onChange={(e) => handleOaeTeoaeChange('right', index, 'amplitude', e.target.value)}
//                               fullWidth
//                             />
//                           </TableCell>
//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>
//               </Grid>

//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle1" fontWeight="bold">Left Ear</Typography>
//                 <TableContainer component={Paper}>
//                   <Table size="small">
//                     <TableHead>
//                       <TableRow>
//                         <TableCell>Frequency (KHz)</TableCell>
//                         <TableCell align="center">SNR (dB SPL)</TableCell>
//                         <TableCell align="center">Amplitude (dB SPL)</TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {oae.teoae.leftEar.map((result, index) => (
//                         <TableRow key={`teoae-left-${index}`}>
//                           <TableCell>
//                             <TextField
//                               size="small"
//                               value={result.freq}
//                               onChange={(e) => handleOaeTeoaeChange('left', index, 'freq', e.target.value)}
//                               fullWidth
//                             />
//                           </TableCell>
//                           <TableCell align="center">
//                             <TextField
//                               size="small"
//                               type="number"
//                               value={result.snr}
//                               onChange={(e) => handleOaeTeoaeChange('left', index, 'snr', e.target.value)}
//                               fullWidth
//                             />
//                           </TableCell>
//                           <TableCell align="center">
//                             <TextField
//                               size="small"
//                               type="number"
//                               value={result.amplitude}
//                               onChange={(e) => handleOaeTeoaeChange('left', index, 'amplitude', e.target.value)}
//                               fullWidth
//                             />
//                           </TableCell>
//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>
//               </Grid>
//             </Grid>

//             {/* DPOAE Section */}
//             <Typography variant="h6" gutterBottom color="primary">
//               DPOAE
//             </Typography>

//             <Grid container spacing={2} sx={{ mb: 2 }}>
//               <Grid item xs={4}>
//                 <TextField
//                   fullWidth
//                   label="f2/f1"
//                   variant="outlined"
//                   value={oae.dpoae.parameters.f2f1}
//                   onChange={(e) => handleOaeParamChange('f2f1', e.target.value)}
//                 />
//               </Grid>
//               <Grid item xs={4}>
//                 <TextField
//                   fullWidth
//                   label="L1"
//                   variant="outlined"
//                   value={oae.dpoae.parameters.l1}
//                   onChange={(e) => handleOaeParamChange('l1', e.target.value)}
//                 />
//               </Grid>
//               <Grid item xs={4}>
//                 <TextField
//                   fullWidth
//                   label="L2"
//                   variant="outlined"
//                   value={oae.dpoae.parameters.l2}
//                   onChange={(e) => handleOaeParamChange('l2', e.target.value)}
//                 />
//               </Grid>
//             </Grid>
//             <Grid container spacing={3} sx={{ mb: 4 }}>
//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle1" fontWeight="bold">Right Ear</Typography>
//                 <TableContainer component={Paper} sx={{ mb: 2 }}>
//                   <Table size="small">
//                     <TableHead>
//                       <TableRow>
//                         <TableCell>Frequency (Hz)</TableCell>
//                         <TableCell align="center">SNR (dB SPL)</TableCell>
//                         <TableCell align="center">Amplitude (dB SPL)</TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {oae.dpoae.rightEar.map((result, index) => (
//                         <TableRow key={`dpoae-right-${index}`}>
//                           <TableCell>
//                             <TextField
//                               size="small"
//                               value={result.freq}
//                               onChange={(e) => handleOaeDpoaeChange('right', index, 'freq', e.target.value)}
//                               fullWidth
//                             />
//                           </TableCell>
//                           <TableCell align="center">
//                             <TextField
//                               size="small"
//                               type="number"
//                               value={result.snr}
//                               onChange={(e) => handleOaeDpoaeChange('right', index, 'snr', e.target.value)}
//                               fullWidth
//                             />
//                           </TableCell>
//                           <TableCell align="center">
//                             <TextField
//                               size="small"
//                               type="number"
//                               value={result.amplitude}
//                               onChange={(e) => handleOaeDpoaeChange('right', index, 'amplitude', e.target.value)}
//                               fullWidth
//                             />
//                           </TableCell>
//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>
//               </Grid>

//               <Grid item xs={12} md={6}>
//                 <Typography variant="subtitle1" fontWeight="bold">Left Ear</Typography>
//                 <TableContainer component={Paper}>
//                   <Table size="small">
//                     <TableHead>
//                       <TableRow>
//                         <TableCell>Frequency (Hz)</TableCell>
//                         <TableCell align="center">SNR (dB SPL)</TableCell>
//                         <TableCell align="center">Amplitude (dB SPL)</TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {oae.dpoae.leftEar.map((result, index) => (
//                         <TableRow key={`dpoae-left-${index}`}>
//                           <TableCell>
//                             <TextField
//                               size="small"
//                               value={result.freq}
//                               onChange={(e) => handleOaeDpoaeChange('left', index, 'freq', e.target.value)}
//                               fullWidth
//                             />
//                           </TableCell>
//                           <TableCell align="center">
//                             <TextField
//                               size="small"
//                               type="number"
//                               value={result.snr}
//                               onChange={(e) => handleOaeDpoaeChange('left', index, 'snr', e.target.value)}
//                               fullWidth
//                             />
//                           </TableCell>
//                           <TableCell align="center">
//                             <TextField
//                               size="small"
//                               type="number"
//                               value={result.amplitude}
//                               onChange={(e) => handleOaeDpoaeChange('left', index, 'amplitude', e.target.value)}
//                               fullWidth
//                             />
//                           </TableCell>
//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>
//               </Grid>
//             </Grid>

//             <TextField
//               fullWidth
//               multiline
//               rows={3}
//               label="Interpretation"
//               value={oae.interpretation}
//               onChange={(e) => setOae(prev => ({ ...prev, interpretation: e.target.value }))}
//               variant="outlined"
//               sx={{ mb: 2 }}
//             />

//             <Button
//               variant="contained"
//               startIcon={<SaveIcon />}
//               onClick={saveOae}
//               sx={{ mt: 2 }}
//             >
//               Save OAE
//             </Button>
//           </Box>

//           {/* ABR Section */}
//           <Box mb={4} border={1} borderColor="divider" p={2} borderRadius={2}>
//             <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
//               Auditory Brainstem Response (ABR)
//             </Typography>

//             <Grid container spacing={2} sx={{ mb: 2 }}>
//               <Grid item xs={12} md={6}>
//                 <TextField
//                   fullWidth
//                   label="Equipment Used"
//                   value={abr.equipmentUsed}
//                   onChange={(e) => handleAbrChange('equipmentUsed', e.target.value)}
//                   variant="outlined"
//                 />
//               </Grid>

//               <Grid item xs={12} md={6}>
//                 <FormControl fullWidth>
//                   <InputLabel shrink={true}>Transducers</InputLabel>
//                   <Select
//                     value={abr.transducers}
//                     onChange={(e) => handleAbrChange('transducers', e.target.value)}
//                     label="Transducers"
//                     displayEmpty
//                     renderValue={value => value || "Select Transducer"}
//                   >
//                     <MenuItem value="Insert receiver">Insert receiver</MenuItem>
//                     <MenuItem value="BC">BC</MenuItem>
//                     <MenuItem value="Headphones">Headphones</MenuItem>
//                     <MenuItem value="Loudspeaker">Loudspeaker</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12} md={6}>
//                 <FormControl fullWidth>
//                   <InputLabel shrink={true}>Stimulus Rate</InputLabel>
//                   <Select
//                     value={abr.stimulusRate}
//                     onChange={(e) => handleAbrChange('stimulusRate', e.target.value)}
//                     label="Stimulus Rate"
//                     displayEmpty
//                     renderValue={value => value || "Select Stimulus Rate"}
//                   >
//                     <MenuItem value="11.1">11.1</MenuItem>
//                     <MenuItem value="30.1">30.1</MenuItem>
//                     <MenuItem value="90.1">90.1</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12} md={6}>
//                 <FormControl fullWidth>
//                   <InputLabel shrink={true}>Stimulus Type</InputLabel>
//                   <Select
//                     value={abr.stimulusType}
//                     onChange={(e) => handleAbrChange('stimulusType', e.target.value)}
//                     label="Stimulus Type"
//                     displayEmpty
//                     renderValue={value => value || "Select Stimulus Type"}
//                   >
//                     <MenuItem value="Click">Click</MenuItem>
//                     <MenuItem value="TB500">TB500</MenuItem>
//                     <MenuItem value="TB1000">TB1000</MenuItem>
//                     <MenuItem value="TB2000">TB2000</MenuItem>
//                     <MenuItem value="TB4000">TB4000</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12} md={6}>
//                 <FormControl fullWidth>
//                   <InputLabel shrink={true}>Ear</InputLabel>
//                   <Select
//                     value={abr.ear}
//                     onChange={(e) => handleAbrChange('ear', e.target.value)}
//                     label="Ear"
//                     displayEmpty
//                     renderValue={value => value || "Select Ear"}
//                   >
//                     <MenuItem value="Right">Right</MenuItem>
//                     <MenuItem value="Left">Left</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12} md={6}>
//                 <FormControl fullWidth>
//                   <InputLabel shrink={true}>Response</InputLabel>
//                   <Select
//                     value={abr.response}
//                     onChange={(e) => handleAbrChange('response', e.target.value)}
//                     label="Response"
//                     displayEmpty
//                     renderValue={value => value || "Select Response"}
//                   >
//                     <MenuItem value="Latency">Latency</MenuItem>
//                     <MenuItem value="Amplitude">Amplitude</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//             </Grid>

//             <Typography variant="subtitle1" gutterBottom>
//               Results
//             </Typography>
//             <TableContainer component={Paper} sx={{ mb: 2 }}>
//               <Table size="small">
//                 <TableHead>
//                   <TableRow>
//                     <TableCell>Intensity (dB)</TableCell>
//                     <TableCell align="center">I</TableCell>
//                     <TableCell align="center">II</TableCell>
//                     <TableCell align="center">III</TableCell>
//                     <TableCell align="center">IV</TableCell>
//                     <TableCell align="center">V</TableCell>
//                     <TableCell align="center">I-III</TableCell>
//                     <TableCell align="center">III-V</TableCell>
//                     <TableCell align="center">V/I</TableCell>
//                     <TableCell align="center">Interaural V</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {[90, 80, 70, 60, 50, 40, 30, 20].map((intensity, rowIndex) => (
//                     <TableRow key={intensity}>
//                       <TableCell>{intensity}</TableCell>
//                       {[0, 1, 2, 3, 4, 5, 6, 7, 8].map((colIndex) => (
//                         <TableCell key={colIndex} align="center">
//                           <TextField
//                             size="small"
//                             fullWidth
//                             value={abr.results[rowIndex][colIndex]}
//                             onChange={(e) => handleAbrResultChange(rowIndex, colIndex, e.target.value)}
//                           />
//                         </TableCell>
//                       ))}
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>

//             <Button
//               variant="contained"
//               startIcon={<SaveIcon />}
//               onClick={saveAbr}
//               sx={{ mt: 2 }}
//             >
//               Save ABR
//             </Button>
//           </Box>

//           {/* Provisional Diagnosis Section */}
//           <Box mb={4} border={1} borderColor="divider" p={2} borderRadius={2}>
//             <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
//               Provisional Diagnosis
//             </Typography>

//             <Box display="flex" alignItems="center" mb={2}>
//               <Typography sx={{ width: '80px' }}>Right</Typography>
//               <TextField
//                 fullWidth
//                 value={provisionalDiagnosis.rightEar}
//                 onChange={(e) => setProvisionalDiagnosis(prev => ({ ...prev, rightEar: e.target.value }))}
//                 variant="outlined"
//               />
//             </Box>

//             <Box display="flex" alignItems="center" mb={2}>
//               <Typography sx={{ width: '80px' }}>Left</Typography>
//               <TextField
//                 fullWidth
//                 value={provisionalDiagnosis.leftEar}
//                 onChange={(e) => setProvisionalDiagnosis(prev => ({ ...prev, leftEar: e.target.value }))}
//                 variant="outlined"
//               />
//             </Box>

//             <Button
//               variant="contained"
//               startIcon={<SaveIcon />}
//               onClick={saveProvisionalDiagnosis}
//               sx={{ mt: 2 }}
//             >
//               Save Provisional Diagnosis
//             </Button>
//           </Box>
//     {/* Password Modal */}
//       <Dialog 
//         open={openPasswordModal} 
//         onClose={handlePasswordModalClose}
//         maxWidth="xs"
//         fullWidth
//       >
//         <DialogTitle>
//           Download Data
//           <IconButton
//             aria-label="close"
//             onClick={handlePasswordModalClose}
//             sx={{
//               position: 'absolute',
//               right: 8,
//               top: 8,
//               color: (theme) => theme.palette.grey[500],
//             }}
//           >
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent>
//           <Box sx={{ mt: 2, mb: 2 }}>
//             <TextField
//               fullWidth
//               label="Password"
//               type="password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               variant="outlined"
//               sx={{ mb: 3 }}
//             />
//             <FormControl fullWidth>
//               <InputLabel>Format</InputLabel>
//               <Select
//                 value={downloadFormat}
//                 onChange={(e) => setDownloadFormat(e.target.value)}
//                 label="Format"
//               >
//                 <MenuItem value="excel">Excel</MenuItem>
//                 <MenuItem value="pdf">PDF</MenuItem>
//               </Select>
//             </FormControl>
//           </Box>
//         </DialogContent>
//         <DialogActions sx={{ p: 2 }}>
//           <Button onClick={handlePasswordModalClose} color="inherit">
//             Cancel
//           </Button>
//           <Button 
//             onClick={handleDownloadConfirm} 
//             variant="contained" 
//             color="primary"
//             disabled={!password}
//           >
//             Download
//           </Button>
//         </DialogActions>
//       </Dialog>
//           {/* Final Submit Button */}
//           <Box display="flex" justifyContent="center" mt={4}>
//             <Button
//               variant="contained"
//               color="primary"
//               size="large"
//               sx={{ px: 6, py: 1.5, fontSize: '1.1rem' }}
//               onClick={handleSubmit}
//             >
//               Submit Evaluation
//             </Button>
//           </Box>
//         </>
//       )}
//     </Paper>
//   );
// };

// export default HearingEvaluationAdult;


import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Card,
  CardContent,
  Divider,
  Stack,
  Container
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import NoteAddIcon from '@mui/icons-material/NoteAdd';

// Initial states for all hearing evaluation fields
const initialPureTone = {
  equipmentUsed: '',
  results: {
    rightAC: Array(10).fill(''),
    rightBC: Array(10).fill(''),
    leftAC: Array(10).fill(''),
    leftBC: Array(10).fill('')
  },
  weber: ['', '', '', '']
};

const initialSpeech = {
  equipmentUsed: '',
  rightEar: { srt: '', sis: '', sdt: '', ucl: '' },
  leftEar: { srt: '', sis: '', sdt: '', ucl: '' }
};

const initialOtoscopy = {
  equipmentUsed: '',
  rightEar: '',
  leftEar: ''
};

const initialTympanometry = {
  equipmentUsed: '',
  rightEar: { type: '', pp: '', sa: '', width: '', ecv: '' },
  leftEar: { type: '', pp: '', sa: '', width: '', ecv: '' },
  interpretation: ''
};

const initialReflexometry = {
  equipmentUsed: '',
  rightEar: { ipsi: ['', '', '', ''], contra: ['', '', '', ''] },
  leftEar: { ipsi: ['', '', '', ''], contra: ['', '', '', ''] },
  interpretation: ''
};

const initialReflexDecay = {
  equipmentUsed: '',
  rightEar: ['', ''],
  leftEar: ['', ''],
  interpretation: ''
};

const initialOae = {
  equipmentUsed: '',
  teoae: {
    rightEar: Array(5).fill({ freq: '', snr: '', amplitude: '' }),
    leftEar: Array(5).fill({ freq: '', snr: '', amplitude: '' })
  },
  dpoae: {
    rightEar: Array(5).fill({ freq: '', snr: '', amplitude: '' }),
    leftEar: Array(5).fill({ freq: '', snr: '', amplitude: '' }),
    parameters: { f2f1: '', l1: '', l2: '' }
  },
  interpretation: ''
};

const initialAbr = {
  equipmentUsed: '',
  transducers: '',
  stimulusRate: '',
  stimulusType: '',
  ear: '',
  response: '',
  results: Array(8).fill('').map(() => Array(9).fill(''))
};

const initialProvisionalDiagnosis = {
  rightEar: '',
  leftEar: ''
};

const HearingEvaluationAdult = () => {
  const [date, setDate] = useState('');
  const [opNumber, setOpNumber] = useState('');
  const [patientData, setPatientData] = useState(null);
  const [demographyData, setDemographyData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saveStatus, setSaveStatus] = useState({ message: '', severity: '' });
  const [openPasswordModal, setOpenPasswordModal] = useState(false);
  const [password, setPassword] = useState('');
  const [downloadFormat, setDownloadFormat] = useState('excel');
  
  // State declarations
  const [pureTone, setPureTone] = useState(initialPureTone);
  const [speech, setSpeech] = useState(initialSpeech);
  const [otoscopy, setOtoscopy] = useState(initialOtoscopy);
  const [tympanometry, setTympanometry] = useState(initialTympanometry);
  const [reflexometry, setReflexometry] = useState(initialReflexometry);
  const [reflexDecay, setReflexDecay] = useState(initialReflexDecay);
  const [oae, setOae] = useState(initialOae);
  const [abr, setAbr] = useState(initialAbr);
  const [previousEvaluations, setPreviousEvaluations] = useState([]);
  const [provisionalDiagnosis, setProvisionalDiagnosis] = useState(initialProvisionalDiagnosis);

  // Frequencies for pure tone audiometry
  const frequencies = [250, 500, 750, 1000, 1500, 2000, 3000, 4000, 6000, 8000];

  // Reset form function
  const resetForm = () => {
    setDate('');
    setOpNumber('');
    setPureTone(initialPureTone);
    setSpeech(initialSpeech);
    setOtoscopy(initialOtoscopy);
    setTympanometry(initialTympanometry);
    setReflexometry(initialReflexometry);
    setReflexDecay(initialReflexDecay);
    setOae(initialOae);
    setAbr(initialAbr);
    setProvisionalDiagnosis(initialProvisionalDiagnosis);
    setPatientData(null);
  };

  // Search for patient
  const handleSearch = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/hearing-evaluation/search/${opNumber}`);
    
        if (!response.ok) {
          throw new Error("Failed to search for patient");
        }
        
        const patient = await response.json();
        setPatientData(patient);
        
        // Store in localStorage for future use
        localStorage.setItem("demography", JSON.stringify(patient));
        
        // Load previous evaluations for this patient
        loadPreviousEvaluations(patient.id);
      } catch (error) {
        console.error("Error:", error);
        setPatientData(null);
        alert("❌ Patient not found. Please try another IP/OP number.");
      }
    };

  // Load previous evaluations
  const loadPreviousEvaluations = async (patientId) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/hearing-evaluation/patient/${patientId}`);
      
      if (response.ok) {
        const evaluations = await response.json();
        setPreviousEvaluations(evaluations);
      }
    } catch (error) {
      console.error("Error loading previous evaluations:", error);
    }
  };

  useEffect(() => {
    const data = localStorage.getItem("demography");
    if (data) {
      try {
        const parsedData = JSON.parse(data);
        setDemographyData(parsedData);
      } catch (error) {
        console.error("Error parsing demography data:", error);
      }
    }
  }, []);

  // Handler functions
  const handlePureToneChange = (e) => {
    const { name, value } = e.target;
    setPureTone(prev => ({ ...prev, [name]: value }));
  };

  const handlePureToneResultChange = (ear, mode, index, value) => {
    setPureTone(prev => {
      const newResults = { ...prev.results };
      newResults[`${ear}${mode}`][index] = value;
      return { ...prev, results: newResults };
    });
  };

  const handleWeberChange = (index, value) => {
    setPureTone(prev => {
      const newWeber = [...prev.weber];
      newWeber[index] = value;
      return { ...prev, weber: newWeber };
    });
  };

  // Save handlers for each section
  const savePureTone = () => {
    console.log('Pure Tone saved:', pureTone);
    alert('Pure Tone Audiometry data saved!');
  };

  const saveSpeech = () => {
    console.log('Speech saved:', speech);
    alert('Speech Audiometry data saved!');
  };

  const saveOtoscopy = () => {
    console.log('Otoscopy saved:', otoscopy);
    alert('Otoscopy data saved!');
  };

  const saveProvisionalDiagnosis = () => {
    console.log('Provisional Diagnosis saved:', provisionalDiagnosis);
    alert('Provisional Diagnosis data saved!');
  };

  const saveTympanometry = () => {
    console.log('Tympanometry saved:', tympanometry);
    alert('Tympanometry data saved!');
  };

  const saveReflexometry = () => {
    console.log('Reflexometry saved:', reflexometry);
    alert('Reflexometry data saved!');
  };

  const saveReflexDecay = () => {
    console.log('Reflex Decay saved:', reflexDecay);
    alert('Reflex Decay data saved!');
  };

  // OAE handlers
  const handleOaeTeoaeChange = (ear, index, field, value) => {
    setOae(prev => {
      const newTeoae = { ...prev.teoae };
      const newEarData = [...newTeoae[`${ear}Ear`]];
      newEarData[index] = { ...newEarData[index], [field]: value };
      newTeoae[`${ear}Ear`] = newEarData;
      return { ...prev, teoae: newTeoae };
    });
  };

  const handleOaeDpoaeChange = (ear, index, field, value) => {
    setOae(prev => {
      const newDpoae = { ...prev.dpoae };
      const newEarData = [...newDpoae[`${ear}Ear`]];
      newEarData[index] = { ...newEarData[index], [field]: value };
      newDpoae[`${ear}Ear`] = newEarData;
      return { ...prev, dpoae: newDpoae };
    });
  };

  const handleOaeParamChange = (field, value) => {
    setOae(prev => ({
      ...prev,
      dpoae: {
        ...prev.dpoae,
        parameters: {
          ...prev.dpoae.parameters,
          [field]: value
        }
      }
    }));
  };

  const saveOae = () => {
    console.log('OAE saved:', oae);
    alert('OAE data saved!');
  };

  const saveAbr = () => {
    console.log('ABR saved:', abr);
    alert('ABR data saved!');
  };

  const handleAbrChange = (field, value) => {
    setAbr(prev => ({ ...prev, [field]: value }));
  };

  const handleAbrResultChange = (rowIndex, colIndex, value) => {
    setAbr(prev => {
      const newResults = prev.results.map((row, rIndex) => {
        if (rIndex === rowIndex) {
          return row.map((cell, cIndex) => (cIndex === colIndex ? value : cell));
        }
        return row;
      });
      return { ...prev, results: newResults };
    });
  };

  const handleSubmit = async () => {
    try {
      if (!patientData || !patientData.id) {
        throw new Error("Patient information is missing. Please register the patient first.");
      }

      // Ensure all fields have proper values (not just empty strings)
      const evaluationData = {
        patientId: patientData.id,
        date: date,
        // Demographic data
        patientName: patientData.name || '',
        patientPhone: patientData.phone || '',
        patientIpNumber: patientData.ip_number || '',
        patientOpNumber: patientData.op_number || '',
        patientAddress: patientData.address || '',
        // Hearing evaluation data - ensure all sections are properly formatted
        pureTone: {
          equipmentUsed: pureTone.equipmentUsed || '',
          results: {
            rightAC: pureTone.results.rightAC.map(val => val || null),
            rightBC: pureTone.results.rightBC.map(val => val || null),
            leftAC: pureTone.results.leftAC.map(val => val || null),
            leftBC: pureTone.results.leftBC.map(val => val || null)
          },
          weber: pureTone.weber.map(val => val || null)
        },
        speech: {
          equipmentUsed: speech.equipmentUsed || '',
          rightEar: {
            srt: speech.rightEar.srt || null,
            sis: speech.rightEar.sis || null,
            sdt: speech.rightEar.sdt || null,
            ucl: speech.rightEar.ucl || null
          },
          leftEar: {
            srt: speech.leftEar.srt || null,
            sis: speech.leftEar.sis || null,
            sdt: speech.leftEar.sdt || null,
            ucl: speech.leftEar.ucl || null
          }
        },
        otoscopy: {
          equipmentUsed: otoscopy.equipmentUsed || '',
          rightEar: otoscopy.rightEar || '',
          leftEar: otoscopy.leftEar || ''
        },
        tympanometry: {
          equipmentUsed: tympanometry.equipmentUsed || '',
          rightEar: {
            type: tympanometry.rightEar.type || '',
            pp: tympanometry.rightEar.pp || null,
            sa: tympanometry.rightEar.sa || null,
            width: tympanometry.rightEar.width || null,
            ecv: tympanometry.rightEar.ecv || null
          },
          leftEar: {
            type: tympanometry.leftEar.type || '',
            pp: tympanometry.leftEar.pp || null,
            sa: tympanometry.leftEar.sa || null,
            width: tympanometry.leftEar.width || null,
            ecv: tympanometry.leftEar.ecv || null
          },
          interpretation: tympanometry.interpretation || ''
        },
        reflexometry: {
          equipmentUsed: reflexometry.equipmentUsed || '',
          rightEar: {
            ipsi: reflexometry.rightEar.ipsi.map(val => val || null),
            contra: reflexometry.rightEar.contra.map(val => val || null)
          },
          leftEar: {
            ipsi: reflexometry.leftEar.ipsi.map(val => val || null),
            contra: reflexometry.leftEar.contra.map(val => val || null)
          },
          interpretation: reflexometry.interpretation || ''
        },
        reflexDecay: {
          equipmentUsed: reflexDecay.equipmentUsed || '',
          rightEar: reflexDecay.rightEar.map(val => val || null),
          leftEar: reflexDecay.leftEar.map(val => val || null),
          interpretation: reflexDecay.interpretation || ''
        },
        oae: {
          equipmentUsed: oae.equipmentUsed || '',
          teoae: {
            rightEar: oae.teoae.rightEar.map(item => ({
              freq: item.freq || null,
              snr: item.snr || null,
              amplitude: item.amplitude || null
            })),
            leftEar: oae.teoae.leftEar.map(item => ({
              freq: item.freq || null,
              snr: item.snr || null,
              amplitude: item.amplitude || null
            }))
          },
          dpoae: {
            parameters: {
              f2f1: oae.dpoae.parameters.f2f1 || null,
              l1: oae.dpoae.parameters.l1 || null,
              l2: oae.dpoae.parameters.l2 || null
            },
            rightEar: oae.dpoae.rightEar.map(item => ({
              freq: item.freq || null,
              snr: item.snr || null,
              amplitude: item.amplitude || null
            })),
            leftEar: oae.dpoae.leftEar.map(item => ({
              freq: item.freq || null,
              snr: item.snr || null,
              amplitude: item.amplitude || null
            }))
          },
          interpretation: oae.interpretation || ''
        },
        abr: {
          equipmentUsed: abr.equipmentUsed || '',
          transducers: abr.transducers || '',
          stimulusRate: abr.stimulusRate || '',
          stimulusType: abr.stimulusType || '',
          ear: abr.ear || '',
          response: abr.response || '',
          results: abr.results.map(row => row.map(cell => cell || null))
        },
        provisionalDiagnosis: {
          rightEar: provisionalDiagnosis.rightEar || '',
          leftEar: provisionalDiagnosis.leftEar || ''
        }
      };
      console.log('Submitting evaluation data:', evaluationData);
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/hearing-evaluation`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(evaluationData),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || "Failed to save hearing evaluation data");
      }

      const data = await response.json();
      alert("✅ Hearing evaluation data saved successfully!");
      console.log("Saved:", data);
      
      // Reset the form after successful submission
      resetForm();
      
      loadPreviousEvaluations(patientData.id);
    } catch (error) {
      console.error("Error:", error);
      alert(`❌ ${error.message}`);
    }
  };

  const handleDownloadClick = () => {
    setOpenPasswordModal(true);
  };

  const handleDownloadConfirm = async () => {
    const correctKey = "Varun@6361";

    // Validate key entered in modal
    if (password !== correctKey) {
      alert("Incorrect key! Download canceled.");
      setPassword('');
      setOpenPasswordModal(false);
      return;
    }

    setOpenPasswordModal(false);
    setLoading(true);
    setSaveStatus({
      message: `Requesting Hearing Evaluation Data  ${downloadFormat}...`,
      severity: "info",
    });

    try {
      const resp = await fetch(
        `${process.env.REACT_APP_API_URL}/api/reports/download-form`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            table: "hearing_evaluation_data",
            formName: "Hearing_Evaluation_Data",
            format: downloadFormat,
            key: password   // 🔥 send KEY instead of password
          }),
        }
      );

      if (!resp.ok) {
        const body = await resp.json().catch(() => ({}));
        setSaveStatus({
          message: `Failed: ${body.message || resp.statusText}`,
          severity: "error",
        });
        return;
      }

      const blob = await resp.blob();
      const disposition = resp.headers.get("content-disposition") || "";

      let filename = `Hearing_Evaluation_Data_${Date.now()}.${
        downloadFormat === "excel" ? "xlsx" : "pdf"
      }`;

      const match = /filename="?([^"]+)"?/.exec(disposition);
      if (match && match[1]) filename = match[1];

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      setSaveStatus({
        message: `Download started: ${filename}`,
        severity: "success",
      });

    } catch (err) {
      console.error("Download error:", err);
      setSaveStatus({
        message: `Error downloading file: ${err.message}`,
        severity: "error",
      });
    } finally {
      setLoading(false);
      setPassword('');
    }
  };

  const handlePasswordModalClose = () => {
    setOpenPasswordModal(false);
    setPassword('');
  };

  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 4 }}>
        {/* Header Section */}
        <Paper elevation={0} sx={{ p: 3, mb: 4, border: '1px solid #e0e0e0' ,width: '90%'  }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
            <Stack direction="row" alignItems="center" spacing={2}>
              <NoteAddIcon sx={{ fontSize: 40, color: 'primary.main' }} />
              <Box>
                <Typography variant="h4" fontWeight={600} color="text.primary">
                  Adult Hearing Evaluation
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  Complete audiological assessment form
                </Typography>
              </Box>
            </Stack>
            
            <Button
              variant="outlined"
              color="primary"
              startIcon={<DownloadIcon />}
              onClick={handleDownloadClick}
              disabled={loading}
              sx={{ 
                borderRadius: 2,
                px: 3,
                textTransform: 'none'
              }}
            >
              Download Data
            </Button>
          </Stack>

          {/* Patient Search Section */}
          <Card variant="outlined" sx={{ mb: 3 }}>
            <CardContent>
              <Typography variant="h6" fontWeight={600} gutterBottom>
                Patient Identification
              </Typography>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={6}>
                  <TextField
                    label="IP/OP Number"
                    value={opNumber}
                    onChange={(e) => setOpNumber(e.target.value)}
                    variant="outlined"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<SearchIcon />}
                    onClick={handleSearch}
                    sx={{ px: 4, py: 1.5, textTransform: 'none' }}
                  >
                    Search Patient
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>

      
        </Paper>

        {/* Only show the form if a patient is found */}
        {patientData && (
          <Paper elevation={0} sx={{ p: 4, border: '1px solid #e0e0e0' }}>
            {/* Date of Assessment */}
            <Box sx={{ mb: 4 }}>
              <Typography variant="h6" fontWeight={600} gutterBottom>
                Assessment Details
              </Typography>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Date of Assessment"
                    type="date"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
              </Grid>
            </Box>

            <Divider sx={{ my: 4 }} />

            {/* Pure Tone Audiometry Section */}
            <Box sx={{ mb: 5 }}>
              <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
                1. Pure Tone Audiometry
              </Typography>
              
              <Card variant="outlined">
                <CardContent>
                  <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Equipment Used"
                        name="equipmentUsed"
                        value={pureTone.equipmentUsed}
                        onChange={handlePureToneChange}
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>

                  <TableContainer component={Paper} sx={{ mb: 3 }}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 600 }}>Mode/Ear</TableCell>
                          {frequencies.map(freq => (
                            <TableCell key={freq} align="center" sx={{ fontWeight: 600 }}>{freq} Hz</TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {[['AC', 'Right'], ['BC', 'Right'], ['AC', 'Left'], ['BC', 'Left']].map(([mode, ear]) => (
                          <TableRow key={`${mode}-${ear}`}>
                            <TableCell sx={{ fontWeight: 500 }}>{mode} - {ear}</TableCell>
                            {frequencies.map((_, index) => (
                              <TableCell key={index} align="center">
                                <TextField
                                  size="small"
                                  type="number"
                                  value={pureTone.results[`${ear.toLowerCase()}${mode}`][index]}
                                  onChange={(e) => handlePureToneResultChange(
                                    ear.toLowerCase(),
                                    mode,
                                    index,
                                    e.target.value
                                  )}
                                  sx={{ width: 70 }}
                                />
                              </TableCell>
                            ))}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {/* Weber Test */}
                  <Typography variant="subtitle1" fontWeight={600} gutterBottom sx={{ mt: 3 }}>
                    Weber Test
                  </Typography>
                  <Grid container spacing={2} sx={{ mb: 2 }}>
                    {[250, 500, 1000, 2000].map((freq, index) => (
                      <Grid item xs={6} sm={3} key={freq}>
                        <FormControl fullWidth>
                          <InputLabel shrink={true}>{freq} Hz</InputLabel>
                          <Select
                            value={pureTone.weber[index]}
                            onChange={(e) => handleWeberChange(index, e.target.value)}
                            label={`${freq} Hz`}
                            displayEmpty
                          >
                            <MenuItem value=""><em>Select Weber</em></MenuItem>
                            <MenuItem value="L">Left</MenuItem>
                            <MenuItem value="R">Right</MenuItem>
                            <MenuItem value="C">Center</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                    ))}
                  </Grid>

                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                    <Button
                      variant="contained"
                      startIcon={<SaveIcon />}
                      onClick={savePureTone}
                      sx={{ textTransform: 'none' }}
                    >
                      Save Pure Tone
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Box>

            <Divider sx={{ my: 4 }} />

            {/* Speech Audiometry Section */}
            <Box sx={{ mb: 5 }}>
              <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
                2. Speech Audiometry
              </Typography>
              
              <Card variant="outlined">
                <CardContent>
                  <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Equipment Used"
                        name="equipmentUsed"
                        value={speech.equipmentUsed}
                        onChange={(e) => setSpeech(prev => ({ ...prev, equipmentUsed: e.target.value }))}
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>

                  <TableContainer component={Paper} sx={{ mb: 3 }}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 600 }}>Ear</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>SRT (dB HL)</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>SIS (%)</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>SDT (dB HL)</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>UCL (dB HL)</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 500 }}>Right</TableCell>
                          <TableCell align="center">
                            <TextField
                              size="small"
                              type="number"
                              fullWidth
                              value={speech.rightEar.srt}
                              onChange={(e) => setSpeech(prev => ({
                                ...prev,
                                rightEar: { ...prev.rightEar, srt: e.target.value }
                              }))}
                            />
                          </TableCell>
                          <TableCell align="center">
                            <TextField
                              size="small"
                              type="number"
                              fullWidth
                              value={speech.rightEar.sis}
                              onChange={(e) => setSpeech(prev => ({
                                ...prev,
                                rightEar: { ...prev.rightEar, sis: e.target.value }
                              }))}
                            />
                          </TableCell>
                          <TableCell align="center">
                            <TextField
                              size="small"
                              type="number"
                              fullWidth
                              value={speech.rightEar.sdt}
                              onChange={(e) => setSpeech(prev => ({
                                ...prev,
                                rightEar: { ...prev.rightEar, sdt: e.target.value }
                              }))}
                            />
                          </TableCell>
                          <TableCell align="center">
                            <TextField
                              size="small"
                              type="number"
                              fullWidth
                              value={speech.rightEar.ucl}
                              onChange={(e) => setSpeech(prev => ({
                                ...prev,
                                rightEar: { ...prev.rightEar, ucl: e.target.value }
                              }))}
                            />
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 500 }}>Left</TableCell>
                          <TableCell align="center">
                            <TextField
                              size="small"
                              type="number"
                              fullWidth
                              value={speech.leftEar.srt}
                              onChange={(e) => setSpeech(prev => ({
                                ...prev,
                                leftEar: { ...prev.leftEar, srt: e.target.value }
                              }))}
                            />
                          </TableCell>
                          <TableCell align="center">
                            <TextField
                              size="small"
                              type="number"
                              fullWidth
                              value={speech.leftEar.sis}
                              onChange={(e) => setSpeech(prev => ({
                                ...prev,
                                leftEar: { ...prev.leftEar, sis: e.target.value }
                              }))}
                            />
                          </TableCell>
                          <TableCell align="center">
                            <TextField
                              size="small"
                              type="number"
                              fullWidth
                              value={speech.leftEar.sdt}
                              onChange={(e) => setSpeech(prev => ({
                                ...prev,
                                leftEar: { ...prev.leftEar, sdt: e.target.value }
                              }))}
                            />
                          </TableCell>
                          <TableCell align="center">
                            <TextField
                              size="small"
                              type="number"
                              fullWidth
                              value={speech.leftEar.ucl}
                              onChange={(e) => setSpeech(prev => ({
                                ...prev,
                                leftEar: { ...prev.leftEar, ucl: e.target.value }
                              }))}
                            />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      variant="contained"
                      startIcon={<SaveIcon />}
                      onClick={saveSpeech}
                      sx={{ textTransform: 'none' }}
                    >
                      Save Speech
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Box>

            <Divider sx={{ my: 4 }} />

            {/* Otoscopy Section */}
            <Box sx={{ mb: 5 }}>
              <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
                3. Otoscopy
              </Typography>
              
              <Card variant="outlined">
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Equipment Used"
                        value={otoscopy.equipmentUsed}
                        onChange={(e) => setOtoscopy(prev => ({ ...prev, equipmentUsed: e.target.value }))}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Right Ear Findings"
                        value={otoscopy.rightEar}
                        onChange={(e) => setOtoscopy(prev => ({ ...prev, rightEar: e.target.value }))}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Left Ear Findings"
                        value={otoscopy.leftEar}
                        onChange={(e) => setOtoscopy(prev => ({ ...prev, leftEar: e.target.value }))}
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>

                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                    <Button
                      variant="contained"
                      startIcon={<SaveIcon />}
                      onClick={saveOtoscopy}
                      sx={{ textTransform: 'none' }}
                    >
                      Save Otoscopy
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Box>

            <Divider sx={{ my: 4 }} />

            {/* Tympanometry Section */}
            <Box sx={{ mb: 5 }}>
              <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
                4. Tympanometry
              </Typography>
              
              <Card variant="outlined">
                <CardContent>
                  <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Equipment Used"
                        value={tympanometry.equipmentUsed}
                        onChange={(e) => setTympanometry(prev => ({ ...prev, equipmentUsed: e.target.value }))}
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>

                  <TableContainer component={Paper} sx={{ mb: 3 }}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 600 }}>Ear</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>Type</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>PP (daPa)</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>SA (mmho)</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>Width (daPa)</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>ECV (cc)</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 500 }}>Right</TableCell>
                          <TableCell align="center">
                            <TextField
                              size="small"
                              value={tympanometry.rightEar.type}
                              onChange={(e) => setTympanometry(prev => ({
                                ...prev,
                                rightEar: { ...prev.rightEar, type: e.target.value }
                              }))}
                              fullWidth
                            />
                          </TableCell>
                          <TableCell align="center">
                            <TextField
                              size="small"
                              type="number"
                              value={tympanometry.rightEar.pp}
                              onChange={(e) => setTympanometry(prev => ({
                                ...prev,
                                rightEar: { ...prev.rightEar, pp: e.target.value }
                              }))}
                              fullWidth
                            />
                          </TableCell>
                          <TableCell align="center">
                            <TextField
                              size="small"
                              type="number"
                              value={tympanometry.rightEar.sa}
                              onChange={(e) => setTympanometry(prev => ({
                                ...prev,
                                rightEar: { ...prev.rightEar, sa: e.target.value }
                              }))}
                              fullWidth
                            />
                          </TableCell>
                          <TableCell align="center">
                            <TextField
                              size="small"
                              type="number"
                              value={tympanometry.rightEar.width}
                              onChange={(e) => setTympanometry(prev => ({
                                ...prev,
                                rightEar: { ...prev.rightEar, width: e.target.value }
                              }))}
                              fullWidth
                            />
                          </TableCell>
                          <TableCell align="center">
                            <TextField
                              size="small"
                              type="number"
                              value={tympanometry.rightEar.ecv}
                              onChange={(e) => setTympanometry(prev => ({
                                ...prev,
                                rightEar: { ...prev.rightEar, ecv: e.target.value }
                              }))}
                              fullWidth
                            />
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 500 }}>Left</TableCell>
                          <TableCell align="center">
                            <TextField
                              size="small"
                              value={tympanometry.leftEar.type}
                              onChange={(e) => setTympanometry(prev => ({
                                ...prev,
                                leftEar: { ...prev.leftEar, type: e.target.value }
                              }))}
                              fullWidth
                            />
                          </TableCell>
                          <TableCell align="center">
                            <TextField
                              size="small"
                              type="number"
                              value={tympanometry.leftEar.pp}
                              onChange={(e) => setTympanometry(prev => ({
                                ...prev,
                                leftEar: { ...prev.leftEar, pp: e.target.value }
                              }))}
                              fullWidth
                            />
                          </TableCell>
                          <TableCell align="center">
                            <TextField
                              size="small"
                              type="number"
                              value={tympanometry.leftEar.sa}
                              onChange={(e) => setTympanometry(prev => ({
                                ...prev,
                                leftEar: { ...prev.leftEar, sa: e.target.value }
                              }))}
                              fullWidth
                            />
                          </TableCell>
                          <TableCell align="center">
                            <TextField
                              size="small"
                              type="number"
                              value={tympanometry.leftEar.width}
                              onChange={(e) => setTympanometry(prev => ({
                                ...prev,
                                leftEar: { ...prev.leftEar, width: e.target.value }
                              }))}
                              fullWidth
                            />
                          </TableCell>
                          <TableCell align="center">
                            <TextField
                              size="small"
                              type="number"
                              value={tympanometry.leftEar.ecv}
                              onChange={(e) => setTympanometry(prev => ({
                                ...prev,
                                leftEar: { ...prev.leftEar, ecv: e.target.value }
                              }))}
                              fullWidth
                            />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    label="Interpretation"
                    value={tympanometry.interpretation}
                    onChange={(e) => setTympanometry(prev => ({ ...prev, interpretation: e.target.value }))}
                    variant="outlined"
                    sx={{ mb: 2 }}
                  />

                  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      variant="contained"
                      startIcon={<SaveIcon />}
                      onClick={saveTympanometry}
                      sx={{ textTransform: 'none' }}
                    >
                      Save Tympanometry
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Box>

            <Divider sx={{ my: 4 }} />

            {/* Reflexometry Section */}
            <Box sx={{ mb: 5 }}>
              <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
                5. Reflexometry
              </Typography>
              
              <Card variant="outlined">
                <CardContent>
                  <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Equipment Used"
                        value={reflexometry.equipmentUsed}
                        onChange={(e) => setReflexometry(prev => ({ ...prev, equipmentUsed: e.target.value }))}
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>

                  <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                    Right Ear
                  </Typography>
                  <TableContainer component={Paper} sx={{ mb: 3 }}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 600 }}>Type</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>500 Hz</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>1000 Hz</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>2000 Hz</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>4000 Hz</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 500 }}>IPSI</TableCell>
                          {[0, 1, 2, 3].map((index) => (
                            <TableCell key={`right-ipsi-${index}`} align="center">
                              <TextField
                                size="small"
                                type="number"
                                fullWidth
                                value={reflexometry.rightEar.ipsi[index]}
                                onChange={(e) => {
                                  const newIpsi = [...reflexometry.rightEar.ipsi];
                                  newIpsi[index] = e.target.value;
                                  setReflexometry(prev => ({
                                    ...prev,
                                    rightEar: { ...prev.rightEar, ipsi: newIpsi }
                                  }));
                                }}
                              />
                            </TableCell>
                          ))}
                        </TableRow>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 500 }}>CONTRA</TableCell>
                          {[0, 1, 2, 3].map((index) => (
                            <TableCell key={`right-contra-${index}`} align="center">
                              <TextField
                                size="small"
                                type="number"
                                fullWidth
                                value={reflexometry.rightEar.contra[index]}
                                onChange={(e) => {
                                  const newContra = [...reflexometry.rightEar.contra];
                                  newContra[index] = e.target.value;
                                  setReflexometry(prev => ({
                                    ...prev,
                                    rightEar: { ...prev.rightEar, contra: newContra }
                                  }));
                                }}
                              />
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                    Left Ear
                  </Typography>
                  <TableContainer component={Paper} sx={{ mb: 3 }}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 600 }}>Type</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>500 Hz</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>1000 Hz</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>2000 Hz</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>4000 Hz</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 500 }}>IPSI</TableCell>
                          {[0, 1, 2, 3].map((index) => (
                            <TableCell key={`left-ipsi-${index}`} align="center">
                              <TextField
                                size="small"
                                type="number"
                                fullWidth
                                value={reflexometry.leftEar.ipsi[index]}
                                onChange={(e) => {
                                  const newIpsi = [...reflexometry.leftEar.ipsi];
                                  newIpsi[index] = e.target.value;
                                  setReflexometry(prev => ({
                                    ...prev,
                                    leftEar: { ...prev.leftEar, ipsi: newIpsi }
                                  }));
                                }}
                              />
                            </TableCell>
                          ))}
                        </TableRow>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 500 }}>CONTRA</TableCell>
                          {[0, 1, 2, 3].map((index) => (
                            <TableCell key={`left-contra-${index}`} align="center">
                              <TextField
                                size="small"
                                type="number"
                                fullWidth
                                value={reflexometry.leftEar.contra[index]}
                                onChange={(e) => {
                                  const newContra = [...reflexometry.leftEar.contra];
                                  newContra[index] = e.target.value;
                                  setReflexometry(prev => ({
                                    ...prev,
                                    leftEar: { ...prev.leftEar, contra: newContra }
                                  }));
                                }}
                              />
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    label="Interpretation"
                    value={reflexometry.interpretation}
                    onChange={(e) => setReflexometry(prev => ({ ...prev, interpretation: e.target.value }))}
                    variant="outlined"
                    sx={{ mb: 2 }}
                  />

                  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      variant="contained"
                      startIcon={<SaveIcon />}
                      onClick={saveReflexometry}
                      sx={{ textTransform: 'none' }}
                    >
                      Save Reflexometry
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Box>

            <Divider sx={{ my: 4 }} />

            {/* Reflex Decay Section */}
            <Box sx={{ mb: 5 }}>
              <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
                6. Reflex Decay
              </Typography>
              
              <Card variant="outlined">
                <CardContent>
                  <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Equipment Used"
                        value={reflexDecay.equipmentUsed}
                        onChange={(e) => setReflexDecay(prev => ({ ...prev, equipmentUsed: e.target.value }))}
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>

                  <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                    Right Ear
                  </Typography>
                  <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid item xs={6}>
                      <FormControl fullWidth>
                        <InputLabel shrink={true}>500 Hz</InputLabel>
                        <Select
                          value={reflexDecay.rightEar[0]}
                          onChange={(e) => {
                            const newRightEar = [...reflexDecay.rightEar];
                            newRightEar[0] = e.target.value;
                            setReflexDecay(prev => ({ ...prev, rightEar: newRightEar }));
                          }}
                          label="500 Hz"
                          displayEmpty
                        >
                          <MenuItem value=""><em>Select</em></MenuItem>
                          <MenuItem value="Positive">Positive</MenuItem>
                          <MenuItem value="Negative">Negative</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl fullWidth>
                        <InputLabel shrink={true}>1000 Hz</InputLabel>
                        <Select
                          value={reflexDecay.rightEar[1]}
                          onChange={(e) => {
                            const newRightEar = [...reflexDecay.rightEar];
                            newRightEar[1] = e.target.value;
                            setReflexDecay(prev => ({ ...prev, rightEar: newRightEar }));
                          }}
                          label="1000 Hz"
                          displayEmpty
                        >
                          <MenuItem value=""><em>Select</em></MenuItem>
                          <MenuItem value="Positive">Positive</MenuItem>
                          <MenuItem value="Negative">Negative</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>

                  <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                    Left Ear
                  </Typography>
                  <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid item xs={6}>
                      <FormControl fullWidth>
                        <InputLabel shrink={true}>500 Hz</InputLabel>
                        <Select
                          value={reflexDecay.leftEar[0]}
                          onChange={(e) => {
                            const newLeftEar = [...reflexDecay.leftEar];
                            newLeftEar[0] = e.target.value;
                            setReflexDecay(prev => ({ ...prev, leftEar: newLeftEar }));
                          }}
                          label="500 Hz"
                          displayEmpty
                        >
                          <MenuItem value=""><em>Select</em></MenuItem>
                          <MenuItem value="Positive">Positive</MenuItem>
                          <MenuItem value="Negative">Negative</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl fullWidth>
                        <InputLabel shrink={true}>1000 Hz</InputLabel>
                        <Select
                          value={reflexDecay.leftEar[1]}
                          onChange={(e) => {
                            const newLeftEar = [...reflexDecay.leftEar];
                            newLeftEar[1] = e.target.value;
                            setReflexDecay(prev => ({ ...prev, leftEar: newLeftEar }));
                          }}
                          label="1000 Hz"
                          displayEmpty
                        >
                          <MenuItem value=""><em>Select</em></MenuItem>
                          <MenuItem value="Positive">Positive</MenuItem>
                          <MenuItem value="Negative">Negative</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>

                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    label="Interpretation"
                    value={reflexDecay.interpretation}
                    onChange={(e) => setReflexDecay(prev => ({ ...prev, interpretation: e.target.value }))}
                    variant="outlined"
                    sx={{ mb: 2 }}
                  />

                  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      variant="contained"
                      startIcon={<SaveIcon />}
                      onClick={saveReflexDecay}
                      sx={{ textTransform: 'none' }}
                    >
                      Save Reflex Decay
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Box>

            <Divider sx={{ my: 4 }} />

            {/* OAE Section */}
            <Box sx={{ mb: 5 }}>
              <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
                7. Oto-acoustic Emissions (OAE)
              </Typography>
              
              <Card variant="outlined">
                <CardContent>
                  <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Equipment Used"
                        value={oae.equipmentUsed}
                        onChange={(e) => setOae(prev => ({ ...prev, equipmentUsed: e.target.value }))}
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>

                  {/* TEOAE Section */}
                  <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                    TEOAE
                  </Typography>
                  <Grid container spacing={3} sx={{ mb: 4 }}>
                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle2" fontWeight={600} gutterBottom>Right Ear</Typography>
                      <TableContainer component={Paper} sx={{ mb: 2 }}>
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              <TableCell sx={{ fontWeight: 600 }}>Frequency (KHz)</TableCell>
                              <TableCell align="center" sx={{ fontWeight: 600 }}>SNR (dB SPL)</TableCell>
                              <TableCell align="center" sx={{ fontWeight: 600 }}>Amplitude (dB SPL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {oae.teoae.rightEar.map((result, index) => (
                              <TableRow key={`teoae-right-${index}`}>
                                <TableCell>
                                  <TextField
                                    size="small"
                                    value={result.freq}
                                    onChange={(e) => handleOaeTeoaeChange('right', index, 'freq', e.target.value)}
                                    fullWidth
                                  />
                                </TableCell>
                                <TableCell align="center">
                                  <TextField
                                    size="small"
                                    type="number"
                                    value={result.snr}
                                    onChange={(e) => handleOaeTeoaeChange('right', index, 'snr', e.target.value)}
                                    fullWidth
                                  />
                                </TableCell>
                                <TableCell align="center">
                                  <TextField
                                    size="small"
                                    type="number"
                                    value={result.amplitude}
                                    onChange={(e) => handleOaeTeoaeChange('right', index, 'amplitude', e.target.value)}
                                    fullWidth
                                  />
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle2" fontWeight={600} gutterBottom>Left Ear</Typography>
                      <TableContainer component={Paper}>
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              <TableCell sx={{ fontWeight: 600 }}>Frequency (KHz)</TableCell>
                              <TableCell align="center" sx={{ fontWeight: 600 }}>SNR (dB SPL)</TableCell>
                              <TableCell align="center" sx={{ fontWeight: 600 }}>Amplitude (dB SPL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {oae.teoae.leftEar.map((result, index) => (
                              <TableRow key={`teoae-left-${index}`}>
                                <TableCell>
                                  <TextField
                                    size="small"
                                    value={result.freq}
                                    onChange={(e) => handleOaeTeoaeChange('left', index, 'freq', e.target.value)}
                                    fullWidth
                                  />
                                </TableCell>
                                <TableCell align="center">
                                  <TextField
                                    size="small"
                                    type="number"
                                    value={result.snr}
                                    onChange={(e) => handleOaeTeoaeChange('left', index, 'snr', e.target.value)}
                                    fullWidth
                                  />
                                </TableCell>
                                <TableCell align="center">
                                  <TextField
                                    size="small"
                                    type="number"
                                    value={result.amplitude}
                                    onChange={(e) => handleOaeTeoaeChange('left', index, 'amplitude', e.target.value)}
                                    fullWidth
                                  />
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                  </Grid>

                  {/* DPOAE Section */}
                  <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                    DPOAE
                  </Typography>

                  <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid item xs={4}>
                      <TextField
                        fullWidth
                        label="f2/f1"
                        variant="outlined"
                        value={oae.dpoae.parameters.f2f1}
                        onChange={(e) => handleOaeParamChange('f2f1', e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        fullWidth
                        label="L1"
                        variant="outlined"
                        value={oae.dpoae.parameters.l1}
                        onChange={(e) => handleOaeParamChange('l1', e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        fullWidth
                        label="L2"
                        variant="outlined"
                        value={oae.dpoae.parameters.l2}
                        onChange={(e) => handleOaeParamChange('l2', e.target.value)}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={3} sx={{ mb: 4 }}>
                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle2" fontWeight={600} gutterBottom>Right Ear</Typography>
                      <TableContainer component={Paper} sx={{ mb: 2 }}>
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              <TableCell sx={{ fontWeight: 600 }}>Frequency (Hz)</TableCell>
                              <TableCell align="center" sx={{ fontWeight: 600 }}>SNR (dB SPL)</TableCell>
                              <TableCell align="center" sx={{ fontWeight: 600 }}>Amplitude (dB SPL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {oae.dpoae.rightEar.map((result, index) => (
                              <TableRow key={`dpoae-right-${index}`}>
                                <TableCell>
                                  <TextField
                                    size="small"
                                    value={result.freq}
                                    onChange={(e) => handleOaeDpoaeChange('right', index, 'freq', e.target.value)}
                                    fullWidth
                                  />
                                </TableCell>
                                <TableCell align="center">
                                  <TextField
                                    size="small"
                                    type="number"
                                    value={result.snr}
                                    onChange={(e) => handleOaeDpoaeChange('right', index, 'snr', e.target.value)}
                                    fullWidth
                                  />
                                </TableCell>
                                <TableCell align="center">
                                  <TextField
                                    size="small"
                                    type="number"
                                    value={result.amplitude}
                                    onChange={(e) => handleOaeDpoaeChange('right', index, 'amplitude', e.target.value)}
                                    fullWidth
                                  />
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle2" fontWeight={600} gutterBottom>Left Ear</Typography>
                      <TableContainer component={Paper}>
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              <TableCell sx={{ fontWeight: 600 }}>Frequency (Hz)</TableCell>
                              <TableCell align="center" sx={{ fontWeight: 600 }}>SNR (dB SPL)</TableCell>
                              <TableCell align="center" sx={{ fontWeight: 600 }}>Amplitude (dB SPL)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {oae.dpoae.leftEar.map((result, index) => (
                              <TableRow key={`dpoae-left-${index}`}>
                                <TableCell>
                                  <TextField
                                    size="small"
                                    value={result.freq}
                                    onChange={(e) => handleOaeDpoaeChange('left', index, 'freq', e.target.value)}
                                    fullWidth
                                  />
                                </TableCell>
                                <TableCell align="center">
                                  <TextField
                                    size="small"
                                    type="number"
                                    value={result.snr}
                                    onChange={(e) => handleOaeDpoaeChange('left', index, 'snr', e.target.value)}
                                    fullWidth
                                  />
                                </TableCell>
                                <TableCell align="center">
                                  <TextField
                                    size="small"
                                    type="number"
                                    value={result.amplitude}
                                    onChange={(e) => handleOaeDpoaeChange('left', index, 'amplitude', e.target.value)}
                                    fullWidth
                                  />
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                  </Grid>

                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    label="Interpretation"
                    value={oae.interpretation}
                    onChange={(e) => setOae(prev => ({ ...prev, interpretation: e.target.value }))}
                    variant="outlined"
                    sx={{ mb: 2 }}
                  />

                  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      variant="contained"
                      startIcon={<SaveIcon />}
                      onClick={saveOae}
                      sx={{ textTransform: 'none' }}
                    >
                      Save OAE
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Box>

            <Divider sx={{ my: 4 }} />

            {/* ABR Section */}
            <Box sx={{ mb: 5 }}>
              <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
                8. Auditory Brainstem Response (ABR)
              </Typography>
              
              <Card variant="outlined">
                <CardContent>
                  <Grid container spacing={2} sx={{ mb: 3 }}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Equipment Used"
                        value={abr.equipmentUsed}
                        onChange={(e) => handleAbrChange('equipmentUsed', e.target.value)}
                        variant="outlined"
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth>
                        <InputLabel shrink={true}>Transducers</InputLabel>
                        <Select
                          value={abr.transducers}
                          onChange={(e) => handleAbrChange('transducers', e.target.value)}
                          label="Transducers"
                          displayEmpty
                        >
                          <MenuItem value=""><em>Select Transducer</em></MenuItem>
                          <MenuItem value="Insert receiver">Insert receiver</MenuItem>
                          <MenuItem value="BC">BC</MenuItem>
                          <MenuItem value="Headphones">Headphones</MenuItem>
                          <MenuItem value="Loudspeaker">Loudspeaker</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth>
                        <InputLabel shrink={true}>Stimulus Rate</InputLabel>
                        <Select
                          value={abr.stimulusRate}
                          onChange={(e) => handleAbrChange('stimulusRate', e.target.value)}
                          label="Stimulus Rate"
                          displayEmpty
                        >
                          <MenuItem value=""><em>Select Stimulus Rate</em></MenuItem>
                          <MenuItem value="11.1">11.1</MenuItem>
                          <MenuItem value="30.1">30.1</MenuItem>
                          <MenuItem value="90.1">90.1</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth>
                        <InputLabel shrink={true}>Stimulus Type</InputLabel>
                        <Select
                          value={abr.stimulusType}
                          onChange={(e) => handleAbrChange('stimulusType', e.target.value)}
                          label="Stimulus Type"
                          displayEmpty
                        >
                          <MenuItem value=""><em>Select Stimulus Type</em></MenuItem>
                          <MenuItem value="Click">Click</MenuItem>
                          <MenuItem value="TB500">TB500</MenuItem>
                          <MenuItem value="TB1000">TB1000</MenuItem>
                          <MenuItem value="TB2000">TB2000</MenuItem>
                          <MenuItem value="TB4000">TB4000</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth>
                        <InputLabel shrink={true}>Ear</InputLabel>
                        <Select
                          value={abr.ear}
                          onChange={(e) => handleAbrChange('ear', e.target.value)}
                          label="Ear"
                          displayEmpty
                        >
                          <MenuItem value=""><em>Select Ear</em></MenuItem>
                          <MenuItem value="Right">Right</MenuItem>
                          <MenuItem value="Left">Left</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <FormControl fullWidth>
                        <InputLabel shrink={true}>Response</InputLabel>
                        <Select
                          value={abr.response}
                          onChange={(e) => handleAbrChange('response', e.target.value)}
                          label="Response"
                          displayEmpty
                        >
                          <MenuItem value=""><em>Select Response</em></MenuItem>
                          <MenuItem value="Latency">Latency</MenuItem>
                          <MenuItem value="Amplitude">Amplitude</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>

                  <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                    Results
                  </Typography>
                  <TableContainer component={Paper} sx={{ mb: 3 }}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 600 }}>Intensity (dB)</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>I</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>II</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>III</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>IV</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>V</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>I-III</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>III-V</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>V/I</TableCell>
                          <TableCell align="center" sx={{ fontWeight: 600 }}>Interaural V</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {[90, 80, 70, 60, 50, 40, 30, 20].map((intensity, rowIndex) => (
                          <TableRow key={intensity}>
                            <TableCell sx={{ fontWeight: 500 }}>{intensity}</TableCell>
                            {[0, 1, 2, 3, 4, 5, 6, 7, 8].map((colIndex) => (
                              <TableCell key={colIndex} align="center">
                                <TextField
                                  size="small"
                                  fullWidth
                                  value={abr.results[rowIndex][colIndex]}
                                  onChange={(e) => handleAbrResultChange(rowIndex, colIndex, e.target.value)}
                                />
                              </TableCell>
                            ))}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      variant="contained"
                      startIcon={<SaveIcon />}
                      onClick={saveAbr}
                      sx={{ textTransform: 'none' }}
                    >
                      Save ABR
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Box>

            <Divider sx={{ my: 4 }} />

            {/* Provisional Diagnosis Section */}
            <Box sx={{ mb: 5 }}>
              <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
                9. Provisional Diagnosis
              </Typography>
              
              <Card variant="outlined">
                <CardContent>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Right Ear"
                        value={provisionalDiagnosis.rightEar}
                        onChange={(e) => setProvisionalDiagnosis(prev => ({ ...prev, rightEar: e.target.value }))}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        label="Left Ear"
                        value={provisionalDiagnosis.leftEar}
                        onChange={(e) => setProvisionalDiagnosis(prev => ({ ...prev, leftEar: e.target.value }))}
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>

                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                    <Button
                      variant="contained"
                      startIcon={<SaveIcon />}
                      onClick={saveProvisionalDiagnosis}
                      sx={{ textTransform: 'none' }}
                    >
                      Save Provisional Diagnosis
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Box>

            {/* Final Submit Button */}
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6 }}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={handleSubmit}
                sx={{ 
                  px: 6,
                  py: 1.5,
                  fontSize: '1.1rem',
                  textTransform: 'none'
                }}
              >
                Submit Evaluation
              </Button>
            </Box>
          </Paper>
        )}
      </Box>

      {/* Download Modal */}
      <Dialog 
        open={openPasswordModal} 
        onClose={handlePasswordModalClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6">Download Data</Typography>
          <IconButton
            aria-label="close"
            onClick={handlePasswordModalClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2, mb: 2 }}>
            <TextField
              fullWidth
              label="Enter Security Key"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              variant="outlined"
              sx={{ mb: 3 }}
              helperText="Enter the security key to download data"
            />
            <FormControl fullWidth>
              <InputLabel>Download Format</InputLabel>
              <Select
                value={downloadFormat}
                onChange={(e) => setDownloadFormat(e.target.value)}
                label="Download Format"
              >
                <MenuItem value="excel">Excel (.xlsx)</MenuItem>
                <MenuItem value="pdf">PDF (.pdf)</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handlePasswordModalClose} color="inherit">
            Cancel
          </Button>
          <Button 
            onClick={handleDownloadConfirm} 
            variant="contained" 
            color="primary"
            disabled={!password}
          >
            Download
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default HearingEvaluationAdult;